import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type Meta = {
  __typename?: 'Meta';
  status?: Maybe<Scalars['JSON']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  _meta?: Maybe<Meta>;
  dailyProtocolTvl?: Maybe<DailyProtocolTvl>;
  dailyProtocolTvls: DailyProtocolTvlPage;
  factory?: Maybe<Factory>;
  factoryDayData?: Maybe<FactoryDayData>;
  factoryDayDatas: FactoryDayDataPage;
  factoryHourData?: Maybe<FactoryHourData>;
  factoryHourDatas: FactoryHourDataPage;
  factorys: FactoryPage;
  feeData?: Maybe<FeeData>;
  feeDatas: FeeDataPage;
  historicalProtocolVolume?: Maybe<HistoricalProtocolVolume>;
  historicalProtocolVolumes: HistoricalProtocolVolumePage;
  historicalTvl?: Maybe<HistoricalTvl>;
  historicalTvls: HistoricalTvlPage;
  historicalVolume?: Maybe<HistoricalVolume>;
  historicalVolumes: HistoricalVolumePage;
  originToken?: Maybe<OriginToken>;
  originTokens: OriginTokenPage;
  pairHistoricalVolume?: Maybe<PairHistoricalVolume>;
  pairHistoricalVolumes: PairHistoricalVolumePage;
  poolTransaction?: Maybe<PoolTransaction>;
  poolTransactions: PoolTransactionPage;
  position?: Maybe<Position>;
  positions: PositionPage;
  priceHistory?: Maybe<PriceHistory>;
  priceHistorys: PriceHistoryPage;
  timestampedOhlc?: Maybe<TimestampedOhlc>;
  timestampedOhlcs: TimestampedOhlcPage;
  token?: Maybe<Token>;
  tokenDayData?: Maybe<TokenDayData>;
  tokenDayDatas: TokenDayDataPage;
  tokenHourData?: Maybe<TokenHourData>;
  tokenHourDatas: TokenHourDataPage;
  tokenMarket?: Maybe<TokenMarket>;
  tokenMarkets: TokenMarketPage;
  tokens: TokenPage;
  user?: Maybe<User>;
  users: UserPage;
  v2Pair?: Maybe<V2Pair>;
  v2PairDayData?: Maybe<V2PairDayData>;
  v2PairDayDatas: V2PairDayDataPage;
  v2PairHourData?: Maybe<V2PairHourData>;
  v2PairHourDatas: V2PairHourDataPage;
  v2PairPriceHistory?: Maybe<V2PairPriceHistory>;
  v2PairPriceHistorys: V2PairPriceHistoryPage;
  v2Pairs: V2PairPage;
  v3Pool?: Maybe<V3Pool>;
  v3PoolDayData?: Maybe<V3PoolDayData>;
  v3PoolDayDatas: V3PoolDayDataPage;
  v3PoolHourData?: Maybe<V3PoolHourData>;
  v3PoolHourDatas: V3PoolHourDataPage;
  v3Pools: V3PoolPage;
  v4Pool?: Maybe<V4Pool>;
  v4PoolDayData?: Maybe<V4PoolDayData>;
  v4PoolDayDatas: V4PoolDayDataPage;
  v4PoolHourData?: Maybe<V4PoolHourData>;
  v4PoolHourDatas: V4PoolHourDataPage;
  v4Pools: V4PoolPage;
};


export type QueryDailyProtocolTvlArgs = {
  id: Scalars['String'];
};


export type QueryDailyProtocolTvlsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<DailyProtocolTvlFilter>;
};


export type QueryFactoryArgs = {
  id: Scalars['String'];
};


export type QueryFactoryDayDataArgs = {
  id: Scalars['String'];
};


export type QueryFactoryDayDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<FactoryDayDataFilter>;
};


export type QueryFactoryHourDataArgs = {
  id: Scalars['String'];
};


export type QueryFactoryHourDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<FactoryHourDataFilter>;
};


export type QueryFactorysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<FactoryFilter>;
};


export type QueryFeeDataArgs = {
  id: Scalars['String'];
};


export type QueryFeeDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<FeeDataFilter>;
};


export type QueryHistoricalProtocolVolumeArgs = {
  id: Scalars['String'];
};


export type QueryHistoricalProtocolVolumesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<HistoricalProtocolVolumeFilter>;
};


export type QueryHistoricalTvlArgs = {
  id: Scalars['String'];
};


export type QueryHistoricalTvlsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<HistoricalTvlFilter>;
};


export type QueryHistoricalVolumeArgs = {
  id: Scalars['String'];
};


export type QueryHistoricalVolumesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<HistoricalVolumeFilter>;
};


export type QueryOriginTokenArgs = {
  id: Scalars['String'];
};


export type QueryOriginTokensArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<OriginTokenFilter>;
};


export type QueryPairHistoricalVolumeArgs = {
  id: Scalars['String'];
};


export type QueryPairHistoricalVolumesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PairHistoricalVolumeFilter>;
};


export type QueryPoolTransactionArgs = {
  id: Scalars['String'];
};


export type QueryPoolTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PoolTransactionFilter>;
};


export type QueryPositionArgs = {
  id: Scalars['String'];
};


export type QueryPositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PositionFilter>;
};


export type QueryPriceHistoryArgs = {
  id: Scalars['String'];
};


export type QueryPriceHistorysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PriceHistoryFilter>;
};


export type QueryTimestampedOhlcArgs = {
  id: Scalars['String'];
};


export type QueryTimestampedOhlcsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<TimestampedOhlcFilter>;
};


export type QueryTokenArgs = {
  id: Scalars['String'];
};


export type QueryTokenDayDataArgs = {
  id: Scalars['String'];
};


export type QueryTokenDayDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<TokenDayDataFilter>;
};


export type QueryTokenHourDataArgs = {
  id: Scalars['String'];
};


export type QueryTokenHourDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<TokenHourDataFilter>;
};


export type QueryTokenMarketArgs = {
  id: Scalars['String'];
};


export type QueryTokenMarketsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<TokenMarketFilter>;
};


export type QueryTokensArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<TokenFilter>;
};


export type QueryUserArgs = {
  id: Scalars['String'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<UserFilter>;
};


export type QueryV2PairArgs = {
  id: Scalars['String'];
};


export type QueryV2PairDayDataArgs = {
  id: Scalars['String'];
};


export type QueryV2PairDayDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V2PairDayDataFilter>;
};


export type QueryV2PairHourDataArgs = {
  id: Scalars['String'];
};


export type QueryV2PairHourDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V2PairHourDataFilter>;
};


export type QueryV2PairPriceHistoryArgs = {
  id: Scalars['String'];
};


export type QueryV2PairPriceHistorysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V2PairPriceHistoryFilter>;
};


export type QueryV2PairsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V2PairFilter>;
};


export type QueryV3PoolArgs = {
  id: Scalars['String'];
};


export type QueryV3PoolDayDataArgs = {
  id: Scalars['String'];
};


export type QueryV3PoolDayDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V3PoolDayDataFilter>;
};


export type QueryV3PoolHourDataArgs = {
  id: Scalars['String'];
};


export type QueryV3PoolHourDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V3PoolHourDataFilter>;
};


export type QueryV3PoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V3PoolFilter>;
};


export type QueryV4PoolArgs = {
  id: Scalars['String'];
};


export type QueryV4PoolDayDataArgs = {
  id: Scalars['String'];
};


export type QueryV4PoolDayDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V4PoolDayDataFilter>;
};


export type QueryV4PoolHourDataArgs = {
  id: Scalars['String'];
};


export type QueryV4PoolHourDatasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V4PoolHourDataFilter>;
};


export type QueryV4PoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V4PoolFilter>;
};

export type ViewPageInfo = {
  __typename?: 'ViewPageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
};

export enum Chain {
  Arbitrum = 'ARBITRUM',
  ArbitrumGoerli = 'ARBITRUM_GOERLI',
  ArbitrumSepolia = 'ARBITRUM_SEPOLIA',
  Avalanche = 'AVALANCHE',
  Base = 'BASE',
  Blast = 'BLAST',
  BlastSepolia = 'BLAST_SEPOLIA',
  Bnb = 'BNB',
  Celo = 'CELO',
  CeloAlfajores = 'CELO_ALFAJORES',
  Ethereum = 'ETHEREUM',
  EthereumGoerli = 'ETHEREUM_GOERLI',
  EthereumSepolia = 'ETHEREUM_SEPOLIA',
  Hyper = 'HYPER',
  Optimism = 'OPTIMISM',
  OptimismGoerli = 'OPTIMISM_GOERLI',
  Polygon = 'POLYGON',
  PolygonMumbai = 'POLYGON_MUMBAI',
  Story = 'STORY',
  StoryOdyssey = 'STORY_ODYSSEY',
  Unichain = 'UNICHAIN',
  UnknownChain = 'UNKNOWN_CHAIN'
}

export type DailyProtocolTvl = {
  __typename?: 'dailyProtocolTvl';
  id: Scalars['String'];
  protocolVersion: ProtocolVersion;
  timestamp: Scalars['BigInt'];
  value?: Maybe<Scalars['Float']>;
};

export type DailyProtocolTvlFilter = {
  AND?: InputMaybe<Array<InputMaybe<DailyProtocolTvlFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DailyProtocolTvlFilter>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  value?: InputMaybe<Scalars['Float']>;
  value_gt?: InputMaybe<Scalars['Float']>;
  value_gte?: InputMaybe<Scalars['Float']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  value_lt?: InputMaybe<Scalars['Float']>;
  value_lte?: InputMaybe<Scalars['Float']>;
  value_not?: InputMaybe<Scalars['Float']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type DailyProtocolTvlPage = {
  __typename?: 'dailyProtocolTvlPage';
  items: Array<DailyProtocolTvl>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Factory = {
  __typename?: 'factory';
  dayData?: Maybe<FactoryDayDataPage>;
  ethPrice: Scalars['String'];
  hourData?: Maybe<FactoryHourDataPage>;
  id: Scalars['String'];
  owner: Scalars['String'];
  pairCount: Scalars['Int'];
  poolCount: Scalars['Int'];
  tokenListUpdatedAt: Scalars['Int'];
  totalFeesETH: Scalars['String'];
  totalFeesUSD: Scalars['String'];
  totalLiquidityETH: Scalars['String'];
  totalLiquidityUSD: Scalars['String'];
  totalValueLockedETH: Scalars['String'];
  totalValueLockedETHUntracked: Scalars['String'];
  totalValueLockedUSD: Scalars['String'];
  totalValueLockedUSDUntracked: Scalars['String'];
  totalVolumeETH: Scalars['String'];
  totalVolumeUSD: Scalars['String'];
  txCount: Scalars['Int'];
  untrackedVolumeUSD: Scalars['String'];
};


export type FactoryDayDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<FactoryDayDataFilter>;
};


export type FactoryHourDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<FactoryHourDataFilter>;
};

export type FactoryDayData = {
  __typename?: 'factoryDayData';
  date: Scalars['BigInt'];
  dayId: Scalars['BigInt'];
  factory?: Maybe<Factory>;
  factoryId: Scalars['String'];
  feesUSD: Scalars['String'];
  id: Scalars['String'];
  protocolVersion: ProtocolVersion;
  tvlUSD: Scalars['String'];
  txCount: Scalars['Int'];
  volumeETH: Scalars['String'];
  volumeUSD: Scalars['String'];
  volumeUSDUntracked: Scalars['String'];
};

export type FactoryDayDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<FactoryDayDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FactoryDayDataFilter>>>;
  date?: InputMaybe<Scalars['BigInt']>;
  date_gt?: InputMaybe<Scalars['BigInt']>;
  date_gte?: InputMaybe<Scalars['BigInt']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  date_lt?: InputMaybe<Scalars['BigInt']>;
  date_lte?: InputMaybe<Scalars['BigInt']>;
  date_not?: InputMaybe<Scalars['BigInt']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId?: InputMaybe<Scalars['BigInt']>;
  dayId_gt?: InputMaybe<Scalars['BigInt']>;
  dayId_gte?: InputMaybe<Scalars['BigInt']>;
  dayId_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId_lt?: InputMaybe<Scalars['BigInt']>;
  dayId_lte?: InputMaybe<Scalars['BigInt']>;
  dayId_not?: InputMaybe<Scalars['BigInt']>;
  dayId_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  factoryId?: InputMaybe<Scalars['String']>;
  factoryId_contains?: InputMaybe<Scalars['String']>;
  factoryId_ends_with?: InputMaybe<Scalars['String']>;
  factoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  factoryId_not?: InputMaybe<Scalars['String']>;
  factoryId_not_contains?: InputMaybe<Scalars['String']>;
  factoryId_not_ends_with?: InputMaybe<Scalars['String']>;
  factoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  factoryId_not_starts_with?: InputMaybe<Scalars['String']>;
  factoryId_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  tvlUSD?: InputMaybe<Scalars['String']>;
  tvlUSD_contains?: InputMaybe<Scalars['String']>;
  tvlUSD_ends_with?: InputMaybe<Scalars['String']>;
  tvlUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tvlUSD_not?: InputMaybe<Scalars['String']>;
  tvlUSD_not_contains?: InputMaybe<Scalars['String']>;
  tvlUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  tvlUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tvlUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  tvlUSD_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['Int']>;
  txCount_gt?: InputMaybe<Scalars['Int']>;
  txCount_gte?: InputMaybe<Scalars['Int']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  txCount_lt?: InputMaybe<Scalars['Int']>;
  txCount_lte?: InputMaybe<Scalars['Int']>;
  txCount_not?: InputMaybe<Scalars['Int']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  volumeETH?: InputMaybe<Scalars['String']>;
  volumeETH_contains?: InputMaybe<Scalars['String']>;
  volumeETH_ends_with?: InputMaybe<Scalars['String']>;
  volumeETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeETH_not?: InputMaybe<Scalars['String']>;
  volumeETH_not_contains?: InputMaybe<Scalars['String']>;
  volumeETH_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeETH_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeETH_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_contains?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSDUntracked_not?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSDUntracked_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type FactoryDayDataPage = {
  __typename?: 'factoryDayDataPage';
  items: Array<FactoryDayData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type FactoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<FactoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FactoryFilter>>>;
  ethPrice?: InputMaybe<Scalars['String']>;
  ethPrice_contains?: InputMaybe<Scalars['String']>;
  ethPrice_ends_with?: InputMaybe<Scalars['String']>;
  ethPrice_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ethPrice_not?: InputMaybe<Scalars['String']>;
  ethPrice_not_contains?: InputMaybe<Scalars['String']>;
  ethPrice_not_ends_with?: InputMaybe<Scalars['String']>;
  ethPrice_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ethPrice_not_starts_with?: InputMaybe<Scalars['String']>;
  ethPrice_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  owner_contains?: InputMaybe<Scalars['String']>;
  owner_ends_with?: InputMaybe<Scalars['String']>;
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  owner_not?: InputMaybe<Scalars['String']>;
  owner_not_contains?: InputMaybe<Scalars['String']>;
  owner_not_ends_with?: InputMaybe<Scalars['String']>;
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  owner_not_starts_with?: InputMaybe<Scalars['String']>;
  owner_starts_with?: InputMaybe<Scalars['String']>;
  pairCount?: InputMaybe<Scalars['Int']>;
  pairCount_gt?: InputMaybe<Scalars['Int']>;
  pairCount_gte?: InputMaybe<Scalars['Int']>;
  pairCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pairCount_lt?: InputMaybe<Scalars['Int']>;
  pairCount_lte?: InputMaybe<Scalars['Int']>;
  pairCount_not?: InputMaybe<Scalars['Int']>;
  pairCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  poolCount?: InputMaybe<Scalars['Int']>;
  poolCount_gt?: InputMaybe<Scalars['Int']>;
  poolCount_gte?: InputMaybe<Scalars['Int']>;
  poolCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  poolCount_lt?: InputMaybe<Scalars['Int']>;
  poolCount_lte?: InputMaybe<Scalars['Int']>;
  poolCount_not?: InputMaybe<Scalars['Int']>;
  poolCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tokenListUpdatedAt?: InputMaybe<Scalars['Int']>;
  tokenListUpdatedAt_gt?: InputMaybe<Scalars['Int']>;
  tokenListUpdatedAt_gte?: InputMaybe<Scalars['Int']>;
  tokenListUpdatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tokenListUpdatedAt_lt?: InputMaybe<Scalars['Int']>;
  tokenListUpdatedAt_lte?: InputMaybe<Scalars['Int']>;
  tokenListUpdatedAt_not?: InputMaybe<Scalars['Int']>;
  tokenListUpdatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  totalFeesETH?: InputMaybe<Scalars['String']>;
  totalFeesETH_contains?: InputMaybe<Scalars['String']>;
  totalFeesETH_ends_with?: InputMaybe<Scalars['String']>;
  totalFeesETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalFeesETH_not?: InputMaybe<Scalars['String']>;
  totalFeesETH_not_contains?: InputMaybe<Scalars['String']>;
  totalFeesETH_not_ends_with?: InputMaybe<Scalars['String']>;
  totalFeesETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalFeesETH_not_starts_with?: InputMaybe<Scalars['String']>;
  totalFeesETH_starts_with?: InputMaybe<Scalars['String']>;
  totalFeesUSD?: InputMaybe<Scalars['String']>;
  totalFeesUSD_contains?: InputMaybe<Scalars['String']>;
  totalFeesUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalFeesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalFeesUSD_not?: InputMaybe<Scalars['String']>;
  totalFeesUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalFeesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalFeesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalFeesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalFeesUSD_starts_with?: InputMaybe<Scalars['String']>;
  totalLiquidityETH?: InputMaybe<Scalars['String']>;
  totalLiquidityETH_contains?: InputMaybe<Scalars['String']>;
  totalLiquidityETH_ends_with?: InputMaybe<Scalars['String']>;
  totalLiquidityETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalLiquidityETH_not?: InputMaybe<Scalars['String']>;
  totalLiquidityETH_not_contains?: InputMaybe<Scalars['String']>;
  totalLiquidityETH_not_ends_with?: InputMaybe<Scalars['String']>;
  totalLiquidityETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalLiquidityETH_not_starts_with?: InputMaybe<Scalars['String']>;
  totalLiquidityETH_starts_with?: InputMaybe<Scalars['String']>;
  totalLiquidityUSD?: InputMaybe<Scalars['String']>;
  totalLiquidityUSD_contains?: InputMaybe<Scalars['String']>;
  totalLiquidityUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalLiquidityUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalLiquidityUSD_not?: InputMaybe<Scalars['String']>;
  totalLiquidityUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalLiquidityUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalLiquidityUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalLiquidityUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalLiquidityUSD_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH?: InputMaybe<Scalars['String']>;
  totalValueLockedETHUntracked?: InputMaybe<Scalars['String']>;
  totalValueLockedETHUntracked_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedETHUntracked_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETHUntracked_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedETHUntracked_not?: InputMaybe<Scalars['String']>;
  totalValueLockedETHUntracked_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedETHUntracked_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETHUntracked_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedETHUntracked_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETHUntracked_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedETH_not?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedETH_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSDUntracked_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSDUntracked_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_starts_with?: InputMaybe<Scalars['String']>;
  totalVolumeETH?: InputMaybe<Scalars['String']>;
  totalVolumeETH_contains?: InputMaybe<Scalars['String']>;
  totalVolumeETH_ends_with?: InputMaybe<Scalars['String']>;
  totalVolumeETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalVolumeETH_not?: InputMaybe<Scalars['String']>;
  totalVolumeETH_not_contains?: InputMaybe<Scalars['String']>;
  totalVolumeETH_not_ends_with?: InputMaybe<Scalars['String']>;
  totalVolumeETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalVolumeETH_not_starts_with?: InputMaybe<Scalars['String']>;
  totalVolumeETH_starts_with?: InputMaybe<Scalars['String']>;
  totalVolumeUSD?: InputMaybe<Scalars['String']>;
  totalVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  totalVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalVolumeUSD_not?: InputMaybe<Scalars['String']>;
  totalVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['Int']>;
  txCount_gt?: InputMaybe<Scalars['Int']>;
  txCount_gte?: InputMaybe<Scalars['Int']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  txCount_lt?: InputMaybe<Scalars['Int']>;
  txCount_lte?: InputMaybe<Scalars['Int']>;
  txCount_not?: InputMaybe<Scalars['Int']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type FactoryHourData = {
  __typename?: 'factoryHourData';
  date: Scalars['BigInt'];
  factory?: Maybe<Factory>;
  factoryId: Scalars['String'];
  feesUSD: Scalars['String'];
  hourId: Scalars['BigInt'];
  id: Scalars['String'];
  protocolVersion: ProtocolVersion;
  tvlUSD: Scalars['String'];
  txCount: Scalars['Int'];
  volumeETH: Scalars['String'];
  volumeUSD: Scalars['String'];
  volumeUSDUntracked: Scalars['String'];
};

export type FactoryHourDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<FactoryHourDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FactoryHourDataFilter>>>;
  date?: InputMaybe<Scalars['BigInt']>;
  date_gt?: InputMaybe<Scalars['BigInt']>;
  date_gte?: InputMaybe<Scalars['BigInt']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  date_lt?: InputMaybe<Scalars['BigInt']>;
  date_lte?: InputMaybe<Scalars['BigInt']>;
  date_not?: InputMaybe<Scalars['BigInt']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  factoryId?: InputMaybe<Scalars['String']>;
  factoryId_contains?: InputMaybe<Scalars['String']>;
  factoryId_ends_with?: InputMaybe<Scalars['String']>;
  factoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  factoryId_not?: InputMaybe<Scalars['String']>;
  factoryId_not_contains?: InputMaybe<Scalars['String']>;
  factoryId_not_ends_with?: InputMaybe<Scalars['String']>;
  factoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  factoryId_not_starts_with?: InputMaybe<Scalars['String']>;
  factoryId_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  hourId?: InputMaybe<Scalars['BigInt']>;
  hourId_gt?: InputMaybe<Scalars['BigInt']>;
  hourId_gte?: InputMaybe<Scalars['BigInt']>;
  hourId_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  hourId_lt?: InputMaybe<Scalars['BigInt']>;
  hourId_lte?: InputMaybe<Scalars['BigInt']>;
  hourId_not?: InputMaybe<Scalars['BigInt']>;
  hourId_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  tvlUSD?: InputMaybe<Scalars['String']>;
  tvlUSD_contains?: InputMaybe<Scalars['String']>;
  tvlUSD_ends_with?: InputMaybe<Scalars['String']>;
  tvlUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tvlUSD_not?: InputMaybe<Scalars['String']>;
  tvlUSD_not_contains?: InputMaybe<Scalars['String']>;
  tvlUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  tvlUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tvlUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  tvlUSD_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['Int']>;
  txCount_gt?: InputMaybe<Scalars['Int']>;
  txCount_gte?: InputMaybe<Scalars['Int']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  txCount_lt?: InputMaybe<Scalars['Int']>;
  txCount_lte?: InputMaybe<Scalars['Int']>;
  txCount_not?: InputMaybe<Scalars['Int']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  volumeETH?: InputMaybe<Scalars['String']>;
  volumeETH_contains?: InputMaybe<Scalars['String']>;
  volumeETH_ends_with?: InputMaybe<Scalars['String']>;
  volumeETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeETH_not?: InputMaybe<Scalars['String']>;
  volumeETH_not_contains?: InputMaybe<Scalars['String']>;
  volumeETH_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeETH_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeETH_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_contains?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSDUntracked_not?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSDUntracked_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSDUntracked_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type FactoryHourDataPage = {
  __typename?: 'factoryHourDataPage';
  items: Array<FactoryHourData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type FactoryPage = {
  __typename?: 'factoryPage';
  items: Array<Factory>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type FeeData = {
  __typename?: 'feeData';
  buyFeeBps?: Maybe<Scalars['String']>;
  externalTransferFailed?: Maybe<Scalars['Boolean']>;
  feeTakenOnTransfer?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  sellFeeBps?: Maybe<Scalars['String']>;
  sellReverted?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Token>;
  tokenId?: Maybe<Scalars['String']>;
};

export type FeeDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<FeeDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FeeDataFilter>>>;
  buyFeeBps?: InputMaybe<Scalars['String']>;
  buyFeeBps_contains?: InputMaybe<Scalars['String']>;
  buyFeeBps_ends_with?: InputMaybe<Scalars['String']>;
  buyFeeBps_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buyFeeBps_not?: InputMaybe<Scalars['String']>;
  buyFeeBps_not_contains?: InputMaybe<Scalars['String']>;
  buyFeeBps_not_ends_with?: InputMaybe<Scalars['String']>;
  buyFeeBps_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buyFeeBps_not_starts_with?: InputMaybe<Scalars['String']>;
  buyFeeBps_starts_with?: InputMaybe<Scalars['String']>;
  externalTransferFailed?: InputMaybe<Scalars['Boolean']>;
  externalTransferFailed_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  externalTransferFailed_not?: InputMaybe<Scalars['Boolean']>;
  externalTransferFailed_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  feeTakenOnTransfer?: InputMaybe<Scalars['Boolean']>;
  feeTakenOnTransfer_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  feeTakenOnTransfer_not?: InputMaybe<Scalars['Boolean']>;
  feeTakenOnTransfer_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  sellFeeBps?: InputMaybe<Scalars['String']>;
  sellFeeBps_contains?: InputMaybe<Scalars['String']>;
  sellFeeBps_ends_with?: InputMaybe<Scalars['String']>;
  sellFeeBps_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sellFeeBps_not?: InputMaybe<Scalars['String']>;
  sellFeeBps_not_contains?: InputMaybe<Scalars['String']>;
  sellFeeBps_not_ends_with?: InputMaybe<Scalars['String']>;
  sellFeeBps_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sellFeeBps_not_starts_with?: InputMaybe<Scalars['String']>;
  sellFeeBps_starts_with?: InputMaybe<Scalars['String']>;
  sellReverted?: InputMaybe<Scalars['Boolean']>;
  sellReverted_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sellReverted_not?: InputMaybe<Scalars['Boolean']>;
  sellReverted_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  tokenId?: InputMaybe<Scalars['String']>;
  tokenId_contains?: InputMaybe<Scalars['String']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not?: InputMaybe<Scalars['String']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']>;
};

export type FeeDataPage = {
  __typename?: 'feeDataPage';
  items: Array<FeeData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type HistoricalProtocolVolume = {
  __typename?: 'historicalProtocolVolume';
  id: Scalars['String'];
  protocolVersion: ProtocolVersion;
  timestamp: Scalars['BigInt'];
  value?: Maybe<Scalars['Float']>;
};

export type HistoricalProtocolVolumeFilter = {
  AND?: InputMaybe<Array<InputMaybe<HistoricalProtocolVolumeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HistoricalProtocolVolumeFilter>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  value?: InputMaybe<Scalars['Float']>;
  value_gt?: InputMaybe<Scalars['Float']>;
  value_gte?: InputMaybe<Scalars['Float']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  value_lt?: InputMaybe<Scalars['Float']>;
  value_lte?: InputMaybe<Scalars['Float']>;
  value_not?: InputMaybe<Scalars['Float']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type HistoricalProtocolVolumePage = {
  __typename?: 'historicalProtocolVolumePage';
  items: Array<HistoricalProtocolVolume>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type HistoricalTvl = {
  __typename?: 'historicalTvl';
  id: Scalars['String'];
  timestamp: Scalars['BigInt'];
  tokenId?: Maybe<Scalars['String']>;
  tokenMarket?: Maybe<TokenMarket>;
  value?: Maybe<Scalars['Float']>;
};

export type HistoricalTvlFilter = {
  AND?: InputMaybe<Array<InputMaybe<HistoricalTvlFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HistoricalTvlFilter>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  tokenId?: InputMaybe<Scalars['String']>;
  tokenId_contains?: InputMaybe<Scalars['String']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not?: InputMaybe<Scalars['String']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
  value_gt?: InputMaybe<Scalars['Float']>;
  value_gte?: InputMaybe<Scalars['Float']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  value_lt?: InputMaybe<Scalars['Float']>;
  value_lte?: InputMaybe<Scalars['Float']>;
  value_not?: InputMaybe<Scalars['Float']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type HistoricalTvlPage = {
  __typename?: 'historicalTvlPage';
  items: Array<HistoricalTvl>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type HistoricalVolume = {
  __typename?: 'historicalVolume';
  id: Scalars['String'];
  timestamp: Scalars['BigInt'];
  tokenId?: Maybe<Scalars['String']>;
  tokenMarket?: Maybe<TokenMarket>;
  value?: Maybe<Scalars['Float']>;
};

export type HistoricalVolumeFilter = {
  AND?: InputMaybe<Array<InputMaybe<HistoricalVolumeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HistoricalVolumeFilter>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  tokenId?: InputMaybe<Scalars['String']>;
  tokenId_contains?: InputMaybe<Scalars['String']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not?: InputMaybe<Scalars['String']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
  value_gt?: InputMaybe<Scalars['Float']>;
  value_gte?: InputMaybe<Scalars['Float']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  value_lt?: InputMaybe<Scalars['Float']>;
  value_lte?: InputMaybe<Scalars['Float']>;
  value_not?: InputMaybe<Scalars['Float']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type HistoricalVolumePage = {
  __typename?: 'historicalVolumePage';
  items: Array<HistoricalVolume>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OriginToken = {
  __typename?: 'originToken';
  address?: Maybe<Scalars['String']>;
  chain: Chain;
  decimals: Scalars['Int'];
  id: Scalars['String'];
  indexText: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  standard: Standard;
  symbol?: Maybe<Scalars['String']>;
  token?: Maybe<Token>;
  tokenId?: Maybe<Scalars['String']>;
};

export type OriginTokenFilter = {
  AND?: InputMaybe<Array<InputMaybe<OriginTokenFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OriginTokenFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  chain?: InputMaybe<Chain>;
  chain_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  chain_not?: InputMaybe<Chain>;
  chain_not_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  decimals?: InputMaybe<Scalars['Int']>;
  decimals_gt?: InputMaybe<Scalars['Int']>;
  decimals_gte?: InputMaybe<Scalars['Int']>;
  decimals_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  decimals_lt?: InputMaybe<Scalars['Int']>;
  decimals_lte?: InputMaybe<Scalars['Int']>;
  decimals_not?: InputMaybe<Scalars['Int']>;
  decimals_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  indexText?: InputMaybe<Scalars['String']>;
  indexText_contains?: InputMaybe<Scalars['String']>;
  indexText_ends_with?: InputMaybe<Scalars['String']>;
  indexText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexText_not?: InputMaybe<Scalars['String']>;
  indexText_not_contains?: InputMaybe<Scalars['String']>;
  indexText_not_ends_with?: InputMaybe<Scalars['String']>;
  indexText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexText_not_starts_with?: InputMaybe<Scalars['String']>;
  indexText_starts_with?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  standard?: InputMaybe<Standard>;
  standard_in?: InputMaybe<Array<InputMaybe<Standard>>>;
  standard_not?: InputMaybe<Standard>;
  standard_not_in?: InputMaybe<Array<InputMaybe<Standard>>>;
  symbol?: InputMaybe<Scalars['String']>;
  symbol_contains?: InputMaybe<Scalars['String']>;
  symbol_ends_with?: InputMaybe<Scalars['String']>;
  symbol_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  symbol_not?: InputMaybe<Scalars['String']>;
  symbol_not_contains?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']>;
  symbol_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']>;
  symbol_starts_with?: InputMaybe<Scalars['String']>;
  tokenId?: InputMaybe<Scalars['String']>;
  tokenId_contains?: InputMaybe<Scalars['String']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not?: InputMaybe<Scalars['String']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']>;
};

export type OriginTokenPage = {
  __typename?: 'originTokenPage';
  items: Array<OriginToken>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PairHistoricalVolume = {
  __typename?: 'pairHistoricalVolume';
  id: Scalars['String'];
  pair?: Maybe<V2Pair>;
  pairId?: Maybe<Scalars['String']>;
  timestamp: Scalars['BigInt'];
  value?: Maybe<Scalars['Float']>;
};

export type PairHistoricalVolumeFilter = {
  AND?: InputMaybe<Array<InputMaybe<PairHistoricalVolumeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PairHistoricalVolumeFilter>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  pairId?: InputMaybe<Scalars['String']>;
  pairId_contains?: InputMaybe<Scalars['String']>;
  pairId_ends_with?: InputMaybe<Scalars['String']>;
  pairId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pairId_not?: InputMaybe<Scalars['String']>;
  pairId_not_contains?: InputMaybe<Scalars['String']>;
  pairId_not_ends_with?: InputMaybe<Scalars['String']>;
  pairId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pairId_not_starts_with?: InputMaybe<Scalars['String']>;
  pairId_starts_with?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  value?: InputMaybe<Scalars['Float']>;
  value_gt?: InputMaybe<Scalars['Float']>;
  value_gte?: InputMaybe<Scalars['Float']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  value_lt?: InputMaybe<Scalars['Float']>;
  value_lte?: InputMaybe<Scalars['Float']>;
  value_not?: InputMaybe<Scalars['Float']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type PairHistoricalVolumePage = {
  __typename?: 'pairHistoricalVolumePage';
  items: Array<PairHistoricalVolume>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PoolTransaction = {
  __typename?: 'poolTransaction';
  account: Scalars['String'];
  chain: Chain;
  hash: Scalars['String'];
  id: Scalars['String'];
  poolId?: Maybe<Scalars['String']>;
  protocolVersion: ProtocolVersion;
  timestamp: Scalars['BigInt'];
  token0?: Maybe<Token>;
  token0Id?: Maybe<Scalars['String']>;
  token0Quantity: Scalars['String'];
  token1?: Maybe<Token>;
  token1Id?: Maybe<Scalars['String']>;
  token1Quantity: Scalars['String'];
  type: PoolTransactionType;
  usdValue: Scalars['String'];
};

export type PoolTransactionFilter = {
  AND?: InputMaybe<Array<InputMaybe<PoolTransactionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PoolTransactionFilter>>>;
  account?: InputMaybe<Scalars['String']>;
  account_contains?: InputMaybe<Scalars['String']>;
  account_ends_with?: InputMaybe<Scalars['String']>;
  account_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  account_not?: InputMaybe<Scalars['String']>;
  account_not_contains?: InputMaybe<Scalars['String']>;
  account_not_ends_with?: InputMaybe<Scalars['String']>;
  account_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  account_not_starts_with?: InputMaybe<Scalars['String']>;
  account_starts_with?: InputMaybe<Scalars['String']>;
  chain?: InputMaybe<Chain>;
  chain_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  chain_not?: InputMaybe<Chain>;
  chain_not_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  hash?: InputMaybe<Scalars['String']>;
  hash_contains?: InputMaybe<Scalars['String']>;
  hash_ends_with?: InputMaybe<Scalars['String']>;
  hash_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hash_not?: InputMaybe<Scalars['String']>;
  hash_not_contains?: InputMaybe<Scalars['String']>;
  hash_not_ends_with?: InputMaybe<Scalars['String']>;
  hash_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hash_not_starts_with?: InputMaybe<Scalars['String']>;
  hash_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  poolId?: InputMaybe<Scalars['String']>;
  poolId_contains?: InputMaybe<Scalars['String']>;
  poolId_ends_with?: InputMaybe<Scalars['String']>;
  poolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not?: InputMaybe<Scalars['String']>;
  poolId_not_contains?: InputMaybe<Scalars['String']>;
  poolId_not_ends_with?: InputMaybe<Scalars['String']>;
  poolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not_starts_with?: InputMaybe<Scalars['String']>;
  poolId_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token0Quantity?: InputMaybe<Scalars['String']>;
  token0Quantity_contains?: InputMaybe<Scalars['String']>;
  token0Quantity_ends_with?: InputMaybe<Scalars['String']>;
  token0Quantity_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Quantity_not?: InputMaybe<Scalars['String']>;
  token0Quantity_not_contains?: InputMaybe<Scalars['String']>;
  token0Quantity_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Quantity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Quantity_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Quantity_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Quantity?: InputMaybe<Scalars['String']>;
  token1Quantity_contains?: InputMaybe<Scalars['String']>;
  token1Quantity_ends_with?: InputMaybe<Scalars['String']>;
  token1Quantity_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Quantity_not?: InputMaybe<Scalars['String']>;
  token1Quantity_not_contains?: InputMaybe<Scalars['String']>;
  token1Quantity_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Quantity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Quantity_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Quantity_starts_with?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PoolTransactionType>;
  type_in?: InputMaybe<Array<InputMaybe<PoolTransactionType>>>;
  type_not?: InputMaybe<PoolTransactionType>;
  type_not_in?: InputMaybe<Array<InputMaybe<PoolTransactionType>>>;
  usdValue?: InputMaybe<Scalars['String']>;
  usdValue_contains?: InputMaybe<Scalars['String']>;
  usdValue_ends_with?: InputMaybe<Scalars['String']>;
  usdValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  usdValue_not?: InputMaybe<Scalars['String']>;
  usdValue_not_contains?: InputMaybe<Scalars['String']>;
  usdValue_not_ends_with?: InputMaybe<Scalars['String']>;
  usdValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  usdValue_not_starts_with?: InputMaybe<Scalars['String']>;
  usdValue_starts_with?: InputMaybe<Scalars['String']>;
};

export type PoolTransactionPage = {
  __typename?: 'poolTransactionPage';
  items: Array<PoolTransaction>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum PoolTransactionType {
  Add = 'ADD',
  Collect = 'COLLECT',
  Remove = 'REMOVE',
  Swap = 'SWAP'
}

export type Position = {
  __typename?: 'position';
  chain: Chain;
  feeTier: Scalars['Int'];
  id: Scalars['String'];
  owner: Scalars['String'];
  protocolVersion: ProtocolVersion;
  timestamp: Scalars['BigInt'];
  token0?: Maybe<Token>;
  token0Id: Scalars['String'];
  token1?: Maybe<Token>;
  token1Id: Scalars['String'];
  v2Pair?: Maybe<V2Pair>;
  v2PairId?: Maybe<Scalars['String']>;
  v3Pool?: Maybe<V3Pool>;
  v3PoolId?: Maybe<Scalars['String']>;
  v4Pool?: Maybe<V4Pool>;
  v4PoolId?: Maybe<Scalars['String']>;
};

export type PositionFilter = {
  AND?: InputMaybe<Array<InputMaybe<PositionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PositionFilter>>>;
  chain?: InputMaybe<Chain>;
  chain_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  chain_not?: InputMaybe<Chain>;
  chain_not_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  feeTier?: InputMaybe<Scalars['Int']>;
  feeTier_gt?: InputMaybe<Scalars['Int']>;
  feeTier_gte?: InputMaybe<Scalars['Int']>;
  feeTier_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  feeTier_lt?: InputMaybe<Scalars['Int']>;
  feeTier_lte?: InputMaybe<Scalars['Int']>;
  feeTier_not?: InputMaybe<Scalars['Int']>;
  feeTier_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  owner_contains?: InputMaybe<Scalars['String']>;
  owner_ends_with?: InputMaybe<Scalars['String']>;
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  owner_not?: InputMaybe<Scalars['String']>;
  owner_not_contains?: InputMaybe<Scalars['String']>;
  owner_not_ends_with?: InputMaybe<Scalars['String']>;
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  owner_not_starts_with?: InputMaybe<Scalars['String']>;
  owner_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  v2PairId?: InputMaybe<Scalars['String']>;
  v2PairId_contains?: InputMaybe<Scalars['String']>;
  v2PairId_ends_with?: InputMaybe<Scalars['String']>;
  v2PairId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  v2PairId_not?: InputMaybe<Scalars['String']>;
  v2PairId_not_contains?: InputMaybe<Scalars['String']>;
  v2PairId_not_ends_with?: InputMaybe<Scalars['String']>;
  v2PairId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  v2PairId_not_starts_with?: InputMaybe<Scalars['String']>;
  v2PairId_starts_with?: InputMaybe<Scalars['String']>;
  v3PoolId?: InputMaybe<Scalars['String']>;
  v3PoolId_contains?: InputMaybe<Scalars['String']>;
  v3PoolId_ends_with?: InputMaybe<Scalars['String']>;
  v3PoolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  v3PoolId_not?: InputMaybe<Scalars['String']>;
  v3PoolId_not_contains?: InputMaybe<Scalars['String']>;
  v3PoolId_not_ends_with?: InputMaybe<Scalars['String']>;
  v3PoolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  v3PoolId_not_starts_with?: InputMaybe<Scalars['String']>;
  v3PoolId_starts_with?: InputMaybe<Scalars['String']>;
  v4PoolId?: InputMaybe<Scalars['String']>;
  v4PoolId_contains?: InputMaybe<Scalars['String']>;
  v4PoolId_ends_with?: InputMaybe<Scalars['String']>;
  v4PoolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  v4PoolId_not?: InputMaybe<Scalars['String']>;
  v4PoolId_not_contains?: InputMaybe<Scalars['String']>;
  v4PoolId_not_ends_with?: InputMaybe<Scalars['String']>;
  v4PoolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  v4PoolId_not_starts_with?: InputMaybe<Scalars['String']>;
  v4PoolId_starts_with?: InputMaybe<Scalars['String']>;
};

export type PositionPage = {
  __typename?: 'positionPage';
  items: Array<Position>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PriceHistory = {
  __typename?: 'priceHistory';
  id: Scalars['String'];
  timestamp: Scalars['BigInt'];
  tokenId?: Maybe<Scalars['String']>;
  tokenMarket?: Maybe<TokenMarket>;
  value?: Maybe<Scalars['Float']>;
};

export type PriceHistoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<PriceHistoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PriceHistoryFilter>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  tokenId?: InputMaybe<Scalars['String']>;
  tokenId_contains?: InputMaybe<Scalars['String']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not?: InputMaybe<Scalars['String']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
  value_gt?: InputMaybe<Scalars['Float']>;
  value_gte?: InputMaybe<Scalars['Float']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  value_lt?: InputMaybe<Scalars['Float']>;
  value_lte?: InputMaybe<Scalars['Float']>;
  value_not?: InputMaybe<Scalars['Float']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type PriceHistoryPage = {
  __typename?: 'priceHistoryPage';
  items: Array<PriceHistory>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum PriceSource {
  SubgraphV2 = 'SUBGRAPH_V2',
  SubgraphV3 = 'SUBGRAPH_V3',
  SubgraphV4 = 'SUBGRAPH_V4'
}

export enum ProtocolVersion {
  V2 = 'V2',
  V3 = 'V3',
  V4 = 'V4'
}

export enum Standard {
  Erc20 = 'ERC20',
  Native = 'NATIVE'
}

export type TimestampedOhlc = {
  __typename?: 'timestampedOhlc';
  close?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  low?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['BigInt']>;
  tokenId?: Maybe<Scalars['String']>;
  tokenMarket?: Maybe<TokenMarket>;
};

export type TimestampedOhlcFilter = {
  AND?: InputMaybe<Array<InputMaybe<TimestampedOhlcFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TimestampedOhlcFilter>>>;
  close?: InputMaybe<Scalars['Float']>;
  close_gt?: InputMaybe<Scalars['Float']>;
  close_gte?: InputMaybe<Scalars['Float']>;
  close_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  close_lt?: InputMaybe<Scalars['Float']>;
  close_lte?: InputMaybe<Scalars['Float']>;
  close_not?: InputMaybe<Scalars['Float']>;
  close_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  high?: InputMaybe<Scalars['Float']>;
  high_gt?: InputMaybe<Scalars['Float']>;
  high_gte?: InputMaybe<Scalars['Float']>;
  high_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  high_lt?: InputMaybe<Scalars['Float']>;
  high_lte?: InputMaybe<Scalars['Float']>;
  high_not?: InputMaybe<Scalars['Float']>;
  high_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  low?: InputMaybe<Scalars['Float']>;
  low_gt?: InputMaybe<Scalars['Float']>;
  low_gte?: InputMaybe<Scalars['Float']>;
  low_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  low_lt?: InputMaybe<Scalars['Float']>;
  low_lte?: InputMaybe<Scalars['Float']>;
  low_not?: InputMaybe<Scalars['Float']>;
  low_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  open?: InputMaybe<Scalars['Float']>;
  open_gt?: InputMaybe<Scalars['Float']>;
  open_gte?: InputMaybe<Scalars['Float']>;
  open_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  open_lt?: InputMaybe<Scalars['Float']>;
  open_lte?: InputMaybe<Scalars['Float']>;
  open_not?: InputMaybe<Scalars['Float']>;
  open_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  tokenId?: InputMaybe<Scalars['String']>;
  tokenId_contains?: InputMaybe<Scalars['String']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not?: InputMaybe<Scalars['String']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']>;
};

export type TimestampedOhlcPage = {
  __typename?: 'timestampedOhlcPage';
  items: Array<TimestampedOhlc>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Token = {
  __typename?: 'token';
  address: Scalars['String'];
  chain: Chain;
  dayData?: Maybe<TokenDayDataPage>;
  decimals: Scalars['Int'];
  derivedETH: Scalars['String'];
  feeData?: Maybe<FeeData>;
  feesUSD: Scalars['String'];
  hourData?: Maybe<TokenHourDataPage>;
  id: Scalars['String'];
  indexText: Scalars['String'];
  market?: Maybe<TokenMarket>;
  name?: Maybe<Scalars['String']>;
  originToken?: Maybe<OriginToken>;
  originTokenId?: Maybe<Scalars['String']>;
  standard: Standard;
  symbol?: Maybe<Scalars['String']>;
  totalValueLocked: Scalars['String'];
  totalValueLockedUSD: Scalars['String'];
  tradeVolume: Scalars['String'];
  tradeVolumeUSD: Scalars['String'];
  transactions?: Maybe<PoolTransactionPage>;
  txCount: Scalars['Int'];
  untrackedVolumeUSD: Scalars['String'];
  v3WhitelistPools?: Maybe<Array<Scalars['String']>>;
  v4WhitelistPools?: Maybe<Array<Scalars['String']>>;
};


export type TokenDayDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<TokenDayDataFilter>;
};


export type TokenHourDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<TokenHourDataFilter>;
};


export type TokenTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PoolTransactionFilter>;
};

export type TokenDayData = {
  __typename?: 'tokenDayData';
  address: Scalars['String'];
  close: Scalars['String'];
  date: Scalars['BigInt'];
  dayId: Scalars['BigInt'];
  feesUSD: Scalars['String'];
  high: Scalars['String'];
  id: Scalars['String'];
  low: Scalars['String'];
  open: Scalars['String'];
  priceUSD: Scalars['String'];
  protocolVersion: ProtocolVersion;
  token?: Maybe<Token>;
  tokenId: Scalars['String'];
  totalValueLocked: Scalars['String'];
  totalValueLockedUSD: Scalars['String'];
  txCount: Scalars['BigInt'];
  untrackedVolumeUSD: Scalars['String'];
  volume: Scalars['String'];
  volumeUSD: Scalars['String'];
};

export type TokenDayDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<TokenDayDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TokenDayDataFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  close?: InputMaybe<Scalars['String']>;
  close_contains?: InputMaybe<Scalars['String']>;
  close_ends_with?: InputMaybe<Scalars['String']>;
  close_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not?: InputMaybe<Scalars['String']>;
  close_not_contains?: InputMaybe<Scalars['String']>;
  close_not_ends_with?: InputMaybe<Scalars['String']>;
  close_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not_starts_with?: InputMaybe<Scalars['String']>;
  close_starts_with?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['BigInt']>;
  date_gt?: InputMaybe<Scalars['BigInt']>;
  date_gte?: InputMaybe<Scalars['BigInt']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  date_lt?: InputMaybe<Scalars['BigInt']>;
  date_lte?: InputMaybe<Scalars['BigInt']>;
  date_not?: InputMaybe<Scalars['BigInt']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId?: InputMaybe<Scalars['BigInt']>;
  dayId_gt?: InputMaybe<Scalars['BigInt']>;
  dayId_gte?: InputMaybe<Scalars['BigInt']>;
  dayId_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId_lt?: InputMaybe<Scalars['BigInt']>;
  dayId_lte?: InputMaybe<Scalars['BigInt']>;
  dayId_not?: InputMaybe<Scalars['BigInt']>;
  dayId_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['String']>;
  high_contains?: InputMaybe<Scalars['String']>;
  high_ends_with?: InputMaybe<Scalars['String']>;
  high_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not?: InputMaybe<Scalars['String']>;
  high_not_contains?: InputMaybe<Scalars['String']>;
  high_not_ends_with?: InputMaybe<Scalars['String']>;
  high_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not_starts_with?: InputMaybe<Scalars['String']>;
  high_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  low?: InputMaybe<Scalars['String']>;
  low_contains?: InputMaybe<Scalars['String']>;
  low_ends_with?: InputMaybe<Scalars['String']>;
  low_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not?: InputMaybe<Scalars['String']>;
  low_not_contains?: InputMaybe<Scalars['String']>;
  low_not_ends_with?: InputMaybe<Scalars['String']>;
  low_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not_starts_with?: InputMaybe<Scalars['String']>;
  low_starts_with?: InputMaybe<Scalars['String']>;
  open?: InputMaybe<Scalars['String']>;
  open_contains?: InputMaybe<Scalars['String']>;
  open_ends_with?: InputMaybe<Scalars['String']>;
  open_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not?: InputMaybe<Scalars['String']>;
  open_not_contains?: InputMaybe<Scalars['String']>;
  open_not_ends_with?: InputMaybe<Scalars['String']>;
  open_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not_starts_with?: InputMaybe<Scalars['String']>;
  open_starts_with?: InputMaybe<Scalars['String']>;
  priceUSD?: InputMaybe<Scalars['String']>;
  priceUSD_contains?: InputMaybe<Scalars['String']>;
  priceUSD_ends_with?: InputMaybe<Scalars['String']>;
  priceUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priceUSD_not?: InputMaybe<Scalars['String']>;
  priceUSD_not_contains?: InputMaybe<Scalars['String']>;
  priceUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  priceUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priceUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  priceUSD_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  tokenId?: InputMaybe<Scalars['String']>;
  tokenId_contains?: InputMaybe<Scalars['String']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not?: InputMaybe<Scalars['String']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLocked?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_contains?: InputMaybe<Scalars['String']>;
  totalValueLocked_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLocked_not?: InputMaybe<Scalars['String']>;
  totalValueLocked_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLocked_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLocked_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['BigInt']>;
  txCount_gt?: InputMaybe<Scalars['BigInt']>;
  txCount_gte?: InputMaybe<Scalars['BigInt']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  txCount_lt?: InputMaybe<Scalars['BigInt']>;
  txCount_lte?: InputMaybe<Scalars['BigInt']>;
  txCount_not?: InputMaybe<Scalars['BigInt']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volume_contains?: InputMaybe<Scalars['String']>;
  volume_ends_with?: InputMaybe<Scalars['String']>;
  volume_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume_not?: InputMaybe<Scalars['String']>;
  volume_not_contains?: InputMaybe<Scalars['String']>;
  volume_not_ends_with?: InputMaybe<Scalars['String']>;
  volume_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume_not_starts_with?: InputMaybe<Scalars['String']>;
  volume_starts_with?: InputMaybe<Scalars['String']>;
};

export type TokenDayDataPage = {
  __typename?: 'tokenDayDataPage';
  items: Array<TokenDayData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TokenFilter = {
  AND?: InputMaybe<Array<InputMaybe<TokenFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TokenFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  chain?: InputMaybe<Chain>;
  chain_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  chain_not?: InputMaybe<Chain>;
  chain_not_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  decimals?: InputMaybe<Scalars['Int']>;
  decimals_gt?: InputMaybe<Scalars['Int']>;
  decimals_gte?: InputMaybe<Scalars['Int']>;
  decimals_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  decimals_lt?: InputMaybe<Scalars['Int']>;
  decimals_lte?: InputMaybe<Scalars['Int']>;
  decimals_not?: InputMaybe<Scalars['Int']>;
  decimals_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  derivedETH?: InputMaybe<Scalars['String']>;
  derivedETH_contains?: InputMaybe<Scalars['String']>;
  derivedETH_ends_with?: InputMaybe<Scalars['String']>;
  derivedETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  derivedETH_not?: InputMaybe<Scalars['String']>;
  derivedETH_not_contains?: InputMaybe<Scalars['String']>;
  derivedETH_not_ends_with?: InputMaybe<Scalars['String']>;
  derivedETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  derivedETH_not_starts_with?: InputMaybe<Scalars['String']>;
  derivedETH_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  indexText?: InputMaybe<Scalars['String']>;
  indexText_contains?: InputMaybe<Scalars['String']>;
  indexText_ends_with?: InputMaybe<Scalars['String']>;
  indexText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexText_not?: InputMaybe<Scalars['String']>;
  indexText_not_contains?: InputMaybe<Scalars['String']>;
  indexText_not_ends_with?: InputMaybe<Scalars['String']>;
  indexText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexText_not_starts_with?: InputMaybe<Scalars['String']>;
  indexText_starts_with?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  originTokenId?: InputMaybe<Scalars['String']>;
  originTokenId_contains?: InputMaybe<Scalars['String']>;
  originTokenId_ends_with?: InputMaybe<Scalars['String']>;
  originTokenId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originTokenId_not?: InputMaybe<Scalars['String']>;
  originTokenId_not_contains?: InputMaybe<Scalars['String']>;
  originTokenId_not_ends_with?: InputMaybe<Scalars['String']>;
  originTokenId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originTokenId_not_starts_with?: InputMaybe<Scalars['String']>;
  originTokenId_starts_with?: InputMaybe<Scalars['String']>;
  standard?: InputMaybe<Standard>;
  standard_in?: InputMaybe<Array<InputMaybe<Standard>>>;
  standard_not?: InputMaybe<Standard>;
  standard_not_in?: InputMaybe<Array<InputMaybe<Standard>>>;
  symbol?: InputMaybe<Scalars['String']>;
  symbol_contains?: InputMaybe<Scalars['String']>;
  symbol_ends_with?: InputMaybe<Scalars['String']>;
  symbol_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  symbol_not?: InputMaybe<Scalars['String']>;
  symbol_not_contains?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']>;
  symbol_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']>;
  symbol_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLocked?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_contains?: InputMaybe<Scalars['String']>;
  totalValueLocked_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLocked_not?: InputMaybe<Scalars['String']>;
  totalValueLocked_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLocked_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLocked_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_starts_with?: InputMaybe<Scalars['String']>;
  tradeVolume?: InputMaybe<Scalars['String']>;
  tradeVolumeUSD?: InputMaybe<Scalars['String']>;
  tradeVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  tradeVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  tradeVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tradeVolumeUSD_not?: InputMaybe<Scalars['String']>;
  tradeVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  tradeVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  tradeVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tradeVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  tradeVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  tradeVolume_contains?: InputMaybe<Scalars['String']>;
  tradeVolume_ends_with?: InputMaybe<Scalars['String']>;
  tradeVolume_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tradeVolume_not?: InputMaybe<Scalars['String']>;
  tradeVolume_not_contains?: InputMaybe<Scalars['String']>;
  tradeVolume_not_ends_with?: InputMaybe<Scalars['String']>;
  tradeVolume_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tradeVolume_not_starts_with?: InputMaybe<Scalars['String']>;
  tradeVolume_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['Int']>;
  txCount_gt?: InputMaybe<Scalars['Int']>;
  txCount_gte?: InputMaybe<Scalars['Int']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  txCount_lt?: InputMaybe<Scalars['Int']>;
  txCount_lte?: InputMaybe<Scalars['Int']>;
  txCount_not?: InputMaybe<Scalars['Int']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  v3WhitelistPools?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  v3WhitelistPools_has?: InputMaybe<Scalars['String']>;
  v3WhitelistPools_not?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  v3WhitelistPools_not_has?: InputMaybe<Scalars['String']>;
  v4WhitelistPools?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  v4WhitelistPools_has?: InputMaybe<Scalars['String']>;
  v4WhitelistPools_not?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  v4WhitelistPools_not_has?: InputMaybe<Scalars['String']>;
};

export type TokenHourData = {
  __typename?: 'tokenHourData';
  address: Scalars['String'];
  close: Scalars['String'];
  date: Scalars['BigInt'];
  dayId: Scalars['BigInt'];
  feesUSD: Scalars['String'];
  high: Scalars['String'];
  id: Scalars['String'];
  low: Scalars['String'];
  open: Scalars['String'];
  priceUSD: Scalars['String'];
  protocolVersion: ProtocolVersion;
  token?: Maybe<Token>;
  tokenId: Scalars['String'];
  totalValueLocked: Scalars['String'];
  totalValueLockedUSD: Scalars['String'];
  txCount: Scalars['BigInt'];
  untrackedVolumeUSD: Scalars['String'];
  volume: Scalars['String'];
  volumeUSD: Scalars['String'];
};

export type TokenHourDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<TokenHourDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TokenHourDataFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  close?: InputMaybe<Scalars['String']>;
  close_contains?: InputMaybe<Scalars['String']>;
  close_ends_with?: InputMaybe<Scalars['String']>;
  close_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not?: InputMaybe<Scalars['String']>;
  close_not_contains?: InputMaybe<Scalars['String']>;
  close_not_ends_with?: InputMaybe<Scalars['String']>;
  close_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not_starts_with?: InputMaybe<Scalars['String']>;
  close_starts_with?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['BigInt']>;
  date_gt?: InputMaybe<Scalars['BigInt']>;
  date_gte?: InputMaybe<Scalars['BigInt']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  date_lt?: InputMaybe<Scalars['BigInt']>;
  date_lte?: InputMaybe<Scalars['BigInt']>;
  date_not?: InputMaybe<Scalars['BigInt']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId?: InputMaybe<Scalars['BigInt']>;
  dayId_gt?: InputMaybe<Scalars['BigInt']>;
  dayId_gte?: InputMaybe<Scalars['BigInt']>;
  dayId_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId_lt?: InputMaybe<Scalars['BigInt']>;
  dayId_lte?: InputMaybe<Scalars['BigInt']>;
  dayId_not?: InputMaybe<Scalars['BigInt']>;
  dayId_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['String']>;
  high_contains?: InputMaybe<Scalars['String']>;
  high_ends_with?: InputMaybe<Scalars['String']>;
  high_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not?: InputMaybe<Scalars['String']>;
  high_not_contains?: InputMaybe<Scalars['String']>;
  high_not_ends_with?: InputMaybe<Scalars['String']>;
  high_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not_starts_with?: InputMaybe<Scalars['String']>;
  high_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  low?: InputMaybe<Scalars['String']>;
  low_contains?: InputMaybe<Scalars['String']>;
  low_ends_with?: InputMaybe<Scalars['String']>;
  low_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not?: InputMaybe<Scalars['String']>;
  low_not_contains?: InputMaybe<Scalars['String']>;
  low_not_ends_with?: InputMaybe<Scalars['String']>;
  low_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not_starts_with?: InputMaybe<Scalars['String']>;
  low_starts_with?: InputMaybe<Scalars['String']>;
  open?: InputMaybe<Scalars['String']>;
  open_contains?: InputMaybe<Scalars['String']>;
  open_ends_with?: InputMaybe<Scalars['String']>;
  open_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not?: InputMaybe<Scalars['String']>;
  open_not_contains?: InputMaybe<Scalars['String']>;
  open_not_ends_with?: InputMaybe<Scalars['String']>;
  open_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not_starts_with?: InputMaybe<Scalars['String']>;
  open_starts_with?: InputMaybe<Scalars['String']>;
  priceUSD?: InputMaybe<Scalars['String']>;
  priceUSD_contains?: InputMaybe<Scalars['String']>;
  priceUSD_ends_with?: InputMaybe<Scalars['String']>;
  priceUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priceUSD_not?: InputMaybe<Scalars['String']>;
  priceUSD_not_contains?: InputMaybe<Scalars['String']>;
  priceUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  priceUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priceUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  priceUSD_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  tokenId?: InputMaybe<Scalars['String']>;
  tokenId_contains?: InputMaybe<Scalars['String']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not?: InputMaybe<Scalars['String']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLocked?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_contains?: InputMaybe<Scalars['String']>;
  totalValueLocked_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLocked_not?: InputMaybe<Scalars['String']>;
  totalValueLocked_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLocked_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLocked_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLocked_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['BigInt']>;
  txCount_gt?: InputMaybe<Scalars['BigInt']>;
  txCount_gte?: InputMaybe<Scalars['BigInt']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  txCount_lt?: InputMaybe<Scalars['BigInt']>;
  txCount_lte?: InputMaybe<Scalars['BigInt']>;
  txCount_not?: InputMaybe<Scalars['BigInt']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volume_contains?: InputMaybe<Scalars['String']>;
  volume_ends_with?: InputMaybe<Scalars['String']>;
  volume_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume_not?: InputMaybe<Scalars['String']>;
  volume_not_contains?: InputMaybe<Scalars['String']>;
  volume_not_ends_with?: InputMaybe<Scalars['String']>;
  volume_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume_not_starts_with?: InputMaybe<Scalars['String']>;
  volume_starts_with?: InputMaybe<Scalars['String']>;
};

export type TokenHourDataPage = {
  __typename?: 'tokenHourDataPage';
  items: Array<TokenHourData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TokenMarket = {
  __typename?: 'tokenMarket';
  historicalTvl?: Maybe<HistoricalTvlPage>;
  historicalVolume?: Maybe<HistoricalVolumePage>;
  id: Scalars['String'];
  ohlc?: Maybe<TimestampedOhlcPage>;
  price?: Maybe<Scalars['Float']>;
  priceHighLow?: Maybe<Scalars['Float']>;
  priceHistory?: Maybe<PriceHistoryPage>;
  pricePercentChange?: Maybe<Scalars['Float']>;
  priceSource: PriceSource;
  token?: Maybe<Token>;
  tokenId?: Maybe<Scalars['String']>;
  totalValueLocked?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};


export type TokenMarketHistoricalTvlArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<HistoricalTvlFilter>;
};


export type TokenMarketHistoricalVolumeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<HistoricalVolumeFilter>;
};


export type TokenMarketOhlcArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<TimestampedOhlcFilter>;
};


export type TokenMarketPriceHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PriceHistoryFilter>;
};

export type TokenMarketFilter = {
  AND?: InputMaybe<Array<InputMaybe<TokenMarketFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TokenMarketFilter>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  priceHighLow?: InputMaybe<Scalars['Float']>;
  priceHighLow_gt?: InputMaybe<Scalars['Float']>;
  priceHighLow_gte?: InputMaybe<Scalars['Float']>;
  priceHighLow_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  priceHighLow_lt?: InputMaybe<Scalars['Float']>;
  priceHighLow_lte?: InputMaybe<Scalars['Float']>;
  priceHighLow_not?: InputMaybe<Scalars['Float']>;
  priceHighLow_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  pricePercentChange?: InputMaybe<Scalars['Float']>;
  pricePercentChange_gt?: InputMaybe<Scalars['Float']>;
  pricePercentChange_gte?: InputMaybe<Scalars['Float']>;
  pricePercentChange_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  pricePercentChange_lt?: InputMaybe<Scalars['Float']>;
  pricePercentChange_lte?: InputMaybe<Scalars['Float']>;
  pricePercentChange_not?: InputMaybe<Scalars['Float']>;
  pricePercentChange_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  priceSource?: InputMaybe<PriceSource>;
  priceSource_in?: InputMaybe<Array<InputMaybe<PriceSource>>>;
  priceSource_not?: InputMaybe<PriceSource>;
  priceSource_not_in?: InputMaybe<Array<InputMaybe<PriceSource>>>;
  price_gt?: InputMaybe<Scalars['Float']>;
  price_gte?: InputMaybe<Scalars['Float']>;
  price_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  price_lt?: InputMaybe<Scalars['Float']>;
  price_lte?: InputMaybe<Scalars['Float']>;
  price_not?: InputMaybe<Scalars['Float']>;
  price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  tokenId?: InputMaybe<Scalars['String']>;
  tokenId_contains?: InputMaybe<Scalars['String']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not?: InputMaybe<Scalars['String']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']>;
  tokenId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLocked?: InputMaybe<Scalars['Float']>;
  totalValueLocked_gt?: InputMaybe<Scalars['Float']>;
  totalValueLocked_gte?: InputMaybe<Scalars['Float']>;
  totalValueLocked_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  totalValueLocked_lt?: InputMaybe<Scalars['Float']>;
  totalValueLocked_lte?: InputMaybe<Scalars['Float']>;
  totalValueLocked_not?: InputMaybe<Scalars['Float']>;
  totalValueLocked_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  volume?: InputMaybe<Scalars['Float']>;
  volume_gt?: InputMaybe<Scalars['Float']>;
  volume_gte?: InputMaybe<Scalars['Float']>;
  volume_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  volume_lt?: InputMaybe<Scalars['Float']>;
  volume_lte?: InputMaybe<Scalars['Float']>;
  volume_not?: InputMaybe<Scalars['Float']>;
  volume_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type TokenMarketPage = {
  __typename?: 'tokenMarketPage';
  items: Array<TokenMarket>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TokenPage = {
  __typename?: 'tokenPage';
  items: Array<Token>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type User = {
  __typename?: 'user';
  id: Scalars['String'];
  usdSwapped?: Maybe<Scalars['Float']>;
};

export type UserFilter = {
  AND?: InputMaybe<Array<InputMaybe<UserFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UserFilter>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  usdSwapped?: InputMaybe<Scalars['Float']>;
  usdSwapped_gt?: InputMaybe<Scalars['Float']>;
  usdSwapped_gte?: InputMaybe<Scalars['Float']>;
  usdSwapped_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  usdSwapped_lt?: InputMaybe<Scalars['Float']>;
  usdSwapped_lte?: InputMaybe<Scalars['Float']>;
  usdSwapped_not?: InputMaybe<Scalars['Float']>;
  usdSwapped_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type UserPage = {
  __typename?: 'userPage';
  items: Array<User>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type V2Pair = {
  __typename?: 'v2Pair';
  address: Scalars['String'];
  chain: Chain;
  createdAtBlockNumber?: Maybe<Scalars['BigInt']>;
  createdAtTimestamp?: Maybe<Scalars['BigInt']>;
  cumulativeVolume?: Maybe<Scalars['BigInt']>;
  dayData?: Maybe<V2PairDayDataPage>;
  hourData?: Maybe<V2PairHourDataPage>;
  id: Scalars['String'];
  indexText: Scalars['String'];
  liquidity: Scalars['String'];
  protocolVersion: ProtocolVersion;
  reserve0: Scalars['BigInt'];
  reserve1: Scalars['BigInt'];
  token0?: Maybe<Token>;
  token0Id: Scalars['String'];
  token0Price: Scalars['String'];
  token0Supply: Scalars['String'];
  token1?: Maybe<Token>;
  token1Id: Scalars['String'];
  token1Price: Scalars['String'];
  token1Supply: Scalars['String'];
  totalLiquidity?: Maybe<Scalars['Float']>;
  totalLiquidityPercentChange24h?: Maybe<Scalars['Float']>;
  totalSupply: Scalars['String'];
  totalValueLockedETH: Scalars['String'];
  totalValueLockedUSD: Scalars['String'];
  trackedReserveETH: Scalars['String'];
  txCount: Scalars['Int'];
  untrackedVolumeUSD: Scalars['String'];
  volumeToken0: Scalars['String'];
  volumeToken1: Scalars['String'];
  volumeUSD: Scalars['String'];
};


export type V2PairDayDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V2PairDayDataFilter>;
};


export type V2PairHourDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V2PairHourDataFilter>;
};

export type V2PairDayData = {
  __typename?: 'v2PairDayData';
  address: Scalars['String'];
  date?: Maybe<Scalars['BigInt']>;
  dayId: Scalars['BigInt'];
  id: Scalars['String'];
  pair?: Maybe<V2Pair>;
  pairId: Scalars['String'];
  protocolVersion: ProtocolVersion;
  token0Id: Scalars['String'];
  token0Price: Scalars['String'];
  token0Supply: Scalars['String'];
  token1Id: Scalars['String'];
  token1Price: Scalars['String'];
  token1Supply: Scalars['String'];
  totalValueLockedUSD: Scalars['String'];
  txCount: Scalars['BigInt'];
  untrackedVolumeUSD: Scalars['String'];
  volumeToken0: Scalars['String'];
  volumeToken1: Scalars['String'];
  volumeUSD: Scalars['String'];
};

export type V2PairDayDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<V2PairDayDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<V2PairDayDataFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['BigInt']>;
  date_gt?: InputMaybe<Scalars['BigInt']>;
  date_gte?: InputMaybe<Scalars['BigInt']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  date_lt?: InputMaybe<Scalars['BigInt']>;
  date_lte?: InputMaybe<Scalars['BigInt']>;
  date_not?: InputMaybe<Scalars['BigInt']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId?: InputMaybe<Scalars['BigInt']>;
  dayId_gt?: InputMaybe<Scalars['BigInt']>;
  dayId_gte?: InputMaybe<Scalars['BigInt']>;
  dayId_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId_lt?: InputMaybe<Scalars['BigInt']>;
  dayId_lte?: InputMaybe<Scalars['BigInt']>;
  dayId_not?: InputMaybe<Scalars['BigInt']>;
  dayId_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  pairId?: InputMaybe<Scalars['String']>;
  pairId_contains?: InputMaybe<Scalars['String']>;
  pairId_ends_with?: InputMaybe<Scalars['String']>;
  pairId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pairId_not?: InputMaybe<Scalars['String']>;
  pairId_not_contains?: InputMaybe<Scalars['String']>;
  pairId_not_ends_with?: InputMaybe<Scalars['String']>;
  pairId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pairId_not_starts_with?: InputMaybe<Scalars['String']>;
  pairId_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token0Price?: InputMaybe<Scalars['String']>;
  token0Price_contains?: InputMaybe<Scalars['String']>;
  token0Price_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not?: InputMaybe<Scalars['String']>;
  token0Price_not_contains?: InputMaybe<Scalars['String']>;
  token0Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Price_starts_with?: InputMaybe<Scalars['String']>;
  token0Supply?: InputMaybe<Scalars['String']>;
  token0Supply_contains?: InputMaybe<Scalars['String']>;
  token0Supply_ends_with?: InputMaybe<Scalars['String']>;
  token0Supply_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Supply_not?: InputMaybe<Scalars['String']>;
  token0Supply_not_contains?: InputMaybe<Scalars['String']>;
  token0Supply_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Supply_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Supply_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Supply_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Price?: InputMaybe<Scalars['String']>;
  token1Price_contains?: InputMaybe<Scalars['String']>;
  token1Price_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not?: InputMaybe<Scalars['String']>;
  token1Price_not_contains?: InputMaybe<Scalars['String']>;
  token1Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Price_starts_with?: InputMaybe<Scalars['String']>;
  token1Supply?: InputMaybe<Scalars['String']>;
  token1Supply_contains?: InputMaybe<Scalars['String']>;
  token1Supply_ends_with?: InputMaybe<Scalars['String']>;
  token1Supply_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Supply_not?: InputMaybe<Scalars['String']>;
  token1Supply_not_contains?: InputMaybe<Scalars['String']>;
  token1Supply_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Supply_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Supply_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Supply_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['BigInt']>;
  txCount_gt?: InputMaybe<Scalars['BigInt']>;
  txCount_gte?: InputMaybe<Scalars['BigInt']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  txCount_lt?: InputMaybe<Scalars['BigInt']>;
  txCount_lte?: InputMaybe<Scalars['BigInt']>;
  txCount_not?: InputMaybe<Scalars['BigInt']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0?: InputMaybe<Scalars['String']>;
  volumeToken0_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not?: InputMaybe<Scalars['String']>;
  volumeToken0_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1?: InputMaybe<Scalars['String']>;
  volumeToken1_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not?: InputMaybe<Scalars['String']>;
  volumeToken1_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type V2PairDayDataPage = {
  __typename?: 'v2PairDayDataPage';
  items: Array<V2PairDayData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type V2PairFilter = {
  AND?: InputMaybe<Array<InputMaybe<V2PairFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<V2PairFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  chain?: InputMaybe<Chain>;
  chain_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  chain_not?: InputMaybe<Chain>;
  chain_not_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  createdAtBlockNumber?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_gt?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_gte?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAtBlockNumber_lt?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_lte?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_not?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAtTimestamp?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_gt?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_gte?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAtTimestamp_lt?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_lte?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_not?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  cumulativeVolume?: InputMaybe<Scalars['BigInt']>;
  cumulativeVolume_gt?: InputMaybe<Scalars['BigInt']>;
  cumulativeVolume_gte?: InputMaybe<Scalars['BigInt']>;
  cumulativeVolume_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  cumulativeVolume_lt?: InputMaybe<Scalars['BigInt']>;
  cumulativeVolume_lte?: InputMaybe<Scalars['BigInt']>;
  cumulativeVolume_not?: InputMaybe<Scalars['BigInt']>;
  cumulativeVolume_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  indexText?: InputMaybe<Scalars['String']>;
  indexText_contains?: InputMaybe<Scalars['String']>;
  indexText_ends_with?: InputMaybe<Scalars['String']>;
  indexText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexText_not?: InputMaybe<Scalars['String']>;
  indexText_not_contains?: InputMaybe<Scalars['String']>;
  indexText_not_ends_with?: InputMaybe<Scalars['String']>;
  indexText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexText_not_starts_with?: InputMaybe<Scalars['String']>;
  indexText_starts_with?: InputMaybe<Scalars['String']>;
  liquidity?: InputMaybe<Scalars['String']>;
  liquidity_contains?: InputMaybe<Scalars['String']>;
  liquidity_ends_with?: InputMaybe<Scalars['String']>;
  liquidity_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  liquidity_not?: InputMaybe<Scalars['String']>;
  liquidity_not_contains?: InputMaybe<Scalars['String']>;
  liquidity_not_ends_with?: InputMaybe<Scalars['String']>;
  liquidity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  liquidity_not_starts_with?: InputMaybe<Scalars['String']>;
  liquidity_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  reserve0?: InputMaybe<Scalars['BigInt']>;
  reserve0_gt?: InputMaybe<Scalars['BigInt']>;
  reserve0_gte?: InputMaybe<Scalars['BigInt']>;
  reserve0_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  reserve0_lt?: InputMaybe<Scalars['BigInt']>;
  reserve0_lte?: InputMaybe<Scalars['BigInt']>;
  reserve0_not?: InputMaybe<Scalars['BigInt']>;
  reserve0_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  reserve1?: InputMaybe<Scalars['BigInt']>;
  reserve1_gt?: InputMaybe<Scalars['BigInt']>;
  reserve1_gte?: InputMaybe<Scalars['BigInt']>;
  reserve1_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  reserve1_lt?: InputMaybe<Scalars['BigInt']>;
  reserve1_lte?: InputMaybe<Scalars['BigInt']>;
  reserve1_not?: InputMaybe<Scalars['BigInt']>;
  reserve1_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token0Price?: InputMaybe<Scalars['String']>;
  token0Price_contains?: InputMaybe<Scalars['String']>;
  token0Price_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not?: InputMaybe<Scalars['String']>;
  token0Price_not_contains?: InputMaybe<Scalars['String']>;
  token0Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Price_starts_with?: InputMaybe<Scalars['String']>;
  token0Supply?: InputMaybe<Scalars['String']>;
  token0Supply_contains?: InputMaybe<Scalars['String']>;
  token0Supply_ends_with?: InputMaybe<Scalars['String']>;
  token0Supply_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Supply_not?: InputMaybe<Scalars['String']>;
  token0Supply_not_contains?: InputMaybe<Scalars['String']>;
  token0Supply_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Supply_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Supply_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Supply_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Price?: InputMaybe<Scalars['String']>;
  token1Price_contains?: InputMaybe<Scalars['String']>;
  token1Price_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not?: InputMaybe<Scalars['String']>;
  token1Price_not_contains?: InputMaybe<Scalars['String']>;
  token1Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Price_starts_with?: InputMaybe<Scalars['String']>;
  token1Supply?: InputMaybe<Scalars['String']>;
  token1Supply_contains?: InputMaybe<Scalars['String']>;
  token1Supply_ends_with?: InputMaybe<Scalars['String']>;
  token1Supply_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Supply_not?: InputMaybe<Scalars['String']>;
  token1Supply_not_contains?: InputMaybe<Scalars['String']>;
  token1Supply_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Supply_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Supply_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Supply_starts_with?: InputMaybe<Scalars['String']>;
  totalLiquidity?: InputMaybe<Scalars['Float']>;
  totalLiquidityPercentChange24h?: InputMaybe<Scalars['Float']>;
  totalLiquidityPercentChange24h_gt?: InputMaybe<Scalars['Float']>;
  totalLiquidityPercentChange24h_gte?: InputMaybe<Scalars['Float']>;
  totalLiquidityPercentChange24h_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  totalLiquidityPercentChange24h_lt?: InputMaybe<Scalars['Float']>;
  totalLiquidityPercentChange24h_lte?: InputMaybe<Scalars['Float']>;
  totalLiquidityPercentChange24h_not?: InputMaybe<Scalars['Float']>;
  totalLiquidityPercentChange24h_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  totalLiquidity_gt?: InputMaybe<Scalars['Float']>;
  totalLiquidity_gte?: InputMaybe<Scalars['Float']>;
  totalLiquidity_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  totalLiquidity_lt?: InputMaybe<Scalars['Float']>;
  totalLiquidity_lte?: InputMaybe<Scalars['Float']>;
  totalLiquidity_not?: InputMaybe<Scalars['Float']>;
  totalLiquidity_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  totalSupply?: InputMaybe<Scalars['String']>;
  totalSupply_contains?: InputMaybe<Scalars['String']>;
  totalSupply_ends_with?: InputMaybe<Scalars['String']>;
  totalSupply_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalSupply_not?: InputMaybe<Scalars['String']>;
  totalSupply_not_contains?: InputMaybe<Scalars['String']>;
  totalSupply_not_ends_with?: InputMaybe<Scalars['String']>;
  totalSupply_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalSupply_not_starts_with?: InputMaybe<Scalars['String']>;
  totalSupply_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedETH_not?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedETH_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_starts_with?: InputMaybe<Scalars['String']>;
  trackedReserveETH?: InputMaybe<Scalars['String']>;
  trackedReserveETH_contains?: InputMaybe<Scalars['String']>;
  trackedReserveETH_ends_with?: InputMaybe<Scalars['String']>;
  trackedReserveETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trackedReserveETH_not?: InputMaybe<Scalars['String']>;
  trackedReserveETH_not_contains?: InputMaybe<Scalars['String']>;
  trackedReserveETH_not_ends_with?: InputMaybe<Scalars['String']>;
  trackedReserveETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trackedReserveETH_not_starts_with?: InputMaybe<Scalars['String']>;
  trackedReserveETH_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['Int']>;
  txCount_gt?: InputMaybe<Scalars['Int']>;
  txCount_gte?: InputMaybe<Scalars['Int']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  txCount_lt?: InputMaybe<Scalars['Int']>;
  txCount_lte?: InputMaybe<Scalars['Int']>;
  txCount_not?: InputMaybe<Scalars['Int']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0?: InputMaybe<Scalars['String']>;
  volumeToken0_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not?: InputMaybe<Scalars['String']>;
  volumeToken0_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1?: InputMaybe<Scalars['String']>;
  volumeToken1_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not?: InputMaybe<Scalars['String']>;
  volumeToken1_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type V2PairHourData = {
  __typename?: 'v2PairHourData';
  address: Scalars['String'];
  date: Scalars['BigInt'];
  dayId: Scalars['BigInt'];
  id: Scalars['String'];
  pair?: Maybe<V2Pair>;
  pairId: Scalars['String'];
  protocolVersion: ProtocolVersion;
  token0Id: Scalars['String'];
  token0Price: Scalars['String'];
  token0Supply: Scalars['String'];
  token1Id: Scalars['String'];
  token1Price: Scalars['String'];
  token1Supply: Scalars['String'];
  totalValueLockedUSD: Scalars['String'];
  txCount: Scalars['BigInt'];
  untrackedVolumeUSD: Scalars['String'];
  volumeToken0: Scalars['String'];
  volumeToken1: Scalars['String'];
  volumeUSD: Scalars['String'];
};

export type V2PairHourDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<V2PairHourDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<V2PairHourDataFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['BigInt']>;
  date_gt?: InputMaybe<Scalars['BigInt']>;
  date_gte?: InputMaybe<Scalars['BigInt']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  date_lt?: InputMaybe<Scalars['BigInt']>;
  date_lte?: InputMaybe<Scalars['BigInt']>;
  date_not?: InputMaybe<Scalars['BigInt']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId?: InputMaybe<Scalars['BigInt']>;
  dayId_gt?: InputMaybe<Scalars['BigInt']>;
  dayId_gte?: InputMaybe<Scalars['BigInt']>;
  dayId_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId_lt?: InputMaybe<Scalars['BigInt']>;
  dayId_lte?: InputMaybe<Scalars['BigInt']>;
  dayId_not?: InputMaybe<Scalars['BigInt']>;
  dayId_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  pairId?: InputMaybe<Scalars['String']>;
  pairId_contains?: InputMaybe<Scalars['String']>;
  pairId_ends_with?: InputMaybe<Scalars['String']>;
  pairId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pairId_not?: InputMaybe<Scalars['String']>;
  pairId_not_contains?: InputMaybe<Scalars['String']>;
  pairId_not_ends_with?: InputMaybe<Scalars['String']>;
  pairId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pairId_not_starts_with?: InputMaybe<Scalars['String']>;
  pairId_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token0Price?: InputMaybe<Scalars['String']>;
  token0Price_contains?: InputMaybe<Scalars['String']>;
  token0Price_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not?: InputMaybe<Scalars['String']>;
  token0Price_not_contains?: InputMaybe<Scalars['String']>;
  token0Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Price_starts_with?: InputMaybe<Scalars['String']>;
  token0Supply?: InputMaybe<Scalars['String']>;
  token0Supply_contains?: InputMaybe<Scalars['String']>;
  token0Supply_ends_with?: InputMaybe<Scalars['String']>;
  token0Supply_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Supply_not?: InputMaybe<Scalars['String']>;
  token0Supply_not_contains?: InputMaybe<Scalars['String']>;
  token0Supply_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Supply_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Supply_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Supply_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Price?: InputMaybe<Scalars['String']>;
  token1Price_contains?: InputMaybe<Scalars['String']>;
  token1Price_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not?: InputMaybe<Scalars['String']>;
  token1Price_not_contains?: InputMaybe<Scalars['String']>;
  token1Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Price_starts_with?: InputMaybe<Scalars['String']>;
  token1Supply?: InputMaybe<Scalars['String']>;
  token1Supply_contains?: InputMaybe<Scalars['String']>;
  token1Supply_ends_with?: InputMaybe<Scalars['String']>;
  token1Supply_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Supply_not?: InputMaybe<Scalars['String']>;
  token1Supply_not_contains?: InputMaybe<Scalars['String']>;
  token1Supply_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Supply_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Supply_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Supply_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['BigInt']>;
  txCount_gt?: InputMaybe<Scalars['BigInt']>;
  txCount_gte?: InputMaybe<Scalars['BigInt']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  txCount_lt?: InputMaybe<Scalars['BigInt']>;
  txCount_lte?: InputMaybe<Scalars['BigInt']>;
  txCount_not?: InputMaybe<Scalars['BigInt']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0?: InputMaybe<Scalars['String']>;
  volumeToken0_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not?: InputMaybe<Scalars['String']>;
  volumeToken0_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1?: InputMaybe<Scalars['String']>;
  volumeToken1_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not?: InputMaybe<Scalars['String']>;
  volumeToken1_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type V2PairHourDataPage = {
  __typename?: 'v2PairHourDataPage';
  items: Array<V2PairHourData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type V2PairPage = {
  __typename?: 'v2PairPage';
  items: Array<V2Pair>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type V2PairPriceHistory = {
  __typename?: 'v2PairPriceHistory';
  id: Scalars['String'];
  pair?: Maybe<V2Pair>;
  pairId?: Maybe<Scalars['String']>;
  timestamp: Scalars['BigInt'];
  token0Price?: Maybe<Scalars['Float']>;
  token1Price?: Maybe<Scalars['Float']>;
};

export type V2PairPriceHistoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<V2PairPriceHistoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<V2PairPriceHistoryFilter>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  pairId?: InputMaybe<Scalars['String']>;
  pairId_contains?: InputMaybe<Scalars['String']>;
  pairId_ends_with?: InputMaybe<Scalars['String']>;
  pairId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pairId_not?: InputMaybe<Scalars['String']>;
  pairId_not_contains?: InputMaybe<Scalars['String']>;
  pairId_not_ends_with?: InputMaybe<Scalars['String']>;
  pairId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pairId_not_starts_with?: InputMaybe<Scalars['String']>;
  pairId_starts_with?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  token0Price?: InputMaybe<Scalars['Float']>;
  token0Price_gt?: InputMaybe<Scalars['Float']>;
  token0Price_gte?: InputMaybe<Scalars['Float']>;
  token0Price_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  token0Price_lt?: InputMaybe<Scalars['Float']>;
  token0Price_lte?: InputMaybe<Scalars['Float']>;
  token0Price_not?: InputMaybe<Scalars['Float']>;
  token0Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  token1Price?: InputMaybe<Scalars['Float']>;
  token1Price_gt?: InputMaybe<Scalars['Float']>;
  token1Price_gte?: InputMaybe<Scalars['Float']>;
  token1Price_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  token1Price_lt?: InputMaybe<Scalars['Float']>;
  token1Price_lte?: InputMaybe<Scalars['Float']>;
  token1Price_not?: InputMaybe<Scalars['Float']>;
  token1Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type V2PairPriceHistoryPage = {
  __typename?: 'v2PairPriceHistoryPage';
  items: Array<V2PairPriceHistory>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type V3Pool = {
  __typename?: 'v3Pool';
  address: Scalars['String'];
  chain: Chain;
  collectedFeesToken0: Scalars['String'];
  collectedFeesToken1: Scalars['String'];
  collectedFeesUSD: Scalars['String'];
  createdAtBlockNumber?: Maybe<Scalars['BigInt']>;
  createdAtTimestamp?: Maybe<Scalars['BigInt']>;
  dayData?: Maybe<V3PoolDayDataPage>;
  feeTier: Scalars['Int'];
  feesUSD: Scalars['String'];
  hourData?: Maybe<V3PoolHourDataPage>;
  id: Scalars['String'];
  indexText: Scalars['String'];
  liquidity: Scalars['String'];
  liquidityProviderCount: Scalars['String'];
  observationIndex?: Maybe<Scalars['BigInt']>;
  protocolVersion: ProtocolVersion;
  sqrtPrice: Scalars['String'];
  tick?: Maybe<Scalars['Int']>;
  token0?: Maybe<Token>;
  token0Id: Scalars['String'];
  token0Price: Scalars['String'];
  token1?: Maybe<Token>;
  token1Id: Scalars['String'];
  token1Price: Scalars['String'];
  totalValueLockedETH: Scalars['String'];
  totalValueLockedToken0: Scalars['String'];
  totalValueLockedToken1: Scalars['String'];
  totalValueLockedUSD: Scalars['String'];
  totalValueLockedUSDUntracked: Scalars['String'];
  txCount: Scalars['Int'];
  untrackedVolumeUSD: Scalars['String'];
  volumeToken0: Scalars['String'];
  volumeToken1: Scalars['String'];
  volumeUSD: Scalars['String'];
};


export type V3PoolDayDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V3PoolDayDataFilter>;
};


export type V3PoolHourDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V3PoolHourDataFilter>;
};

export type V3PoolDayData = {
  __typename?: 'v3PoolDayData';
  address: Scalars['String'];
  close: Scalars['String'];
  date?: Maybe<Scalars['BigInt']>;
  dayId: Scalars['BigInt'];
  feesUSD: Scalars['String'];
  high: Scalars['String'];
  id: Scalars['String'];
  low: Scalars['String'];
  open: Scalars['String'];
  pool?: Maybe<V3Pool>;
  poolId: Scalars['String'];
  protocolVersion: ProtocolVersion;
  token0Id: Scalars['String'];
  token0Price: Scalars['String'];
  token1Id: Scalars['String'];
  token1Price: Scalars['String'];
  txCount: Scalars['BigInt'];
  untrackedVolumeUSD: Scalars['String'];
  volumeToken0: Scalars['String'];
  volumeToken1: Scalars['String'];
  volumeUSD: Scalars['String'];
};

export type V3PoolDayDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<V3PoolDayDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<V3PoolDayDataFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  close?: InputMaybe<Scalars['String']>;
  close_contains?: InputMaybe<Scalars['String']>;
  close_ends_with?: InputMaybe<Scalars['String']>;
  close_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not?: InputMaybe<Scalars['String']>;
  close_not_contains?: InputMaybe<Scalars['String']>;
  close_not_ends_with?: InputMaybe<Scalars['String']>;
  close_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not_starts_with?: InputMaybe<Scalars['String']>;
  close_starts_with?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['BigInt']>;
  date_gt?: InputMaybe<Scalars['BigInt']>;
  date_gte?: InputMaybe<Scalars['BigInt']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  date_lt?: InputMaybe<Scalars['BigInt']>;
  date_lte?: InputMaybe<Scalars['BigInt']>;
  date_not?: InputMaybe<Scalars['BigInt']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId?: InputMaybe<Scalars['BigInt']>;
  dayId_gt?: InputMaybe<Scalars['BigInt']>;
  dayId_gte?: InputMaybe<Scalars['BigInt']>;
  dayId_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId_lt?: InputMaybe<Scalars['BigInt']>;
  dayId_lte?: InputMaybe<Scalars['BigInt']>;
  dayId_not?: InputMaybe<Scalars['BigInt']>;
  dayId_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['String']>;
  high_contains?: InputMaybe<Scalars['String']>;
  high_ends_with?: InputMaybe<Scalars['String']>;
  high_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not?: InputMaybe<Scalars['String']>;
  high_not_contains?: InputMaybe<Scalars['String']>;
  high_not_ends_with?: InputMaybe<Scalars['String']>;
  high_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not_starts_with?: InputMaybe<Scalars['String']>;
  high_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  low?: InputMaybe<Scalars['String']>;
  low_contains?: InputMaybe<Scalars['String']>;
  low_ends_with?: InputMaybe<Scalars['String']>;
  low_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not?: InputMaybe<Scalars['String']>;
  low_not_contains?: InputMaybe<Scalars['String']>;
  low_not_ends_with?: InputMaybe<Scalars['String']>;
  low_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not_starts_with?: InputMaybe<Scalars['String']>;
  low_starts_with?: InputMaybe<Scalars['String']>;
  open?: InputMaybe<Scalars['String']>;
  open_contains?: InputMaybe<Scalars['String']>;
  open_ends_with?: InputMaybe<Scalars['String']>;
  open_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not?: InputMaybe<Scalars['String']>;
  open_not_contains?: InputMaybe<Scalars['String']>;
  open_not_ends_with?: InputMaybe<Scalars['String']>;
  open_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not_starts_with?: InputMaybe<Scalars['String']>;
  open_starts_with?: InputMaybe<Scalars['String']>;
  poolId?: InputMaybe<Scalars['String']>;
  poolId_contains?: InputMaybe<Scalars['String']>;
  poolId_ends_with?: InputMaybe<Scalars['String']>;
  poolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not?: InputMaybe<Scalars['String']>;
  poolId_not_contains?: InputMaybe<Scalars['String']>;
  poolId_not_ends_with?: InputMaybe<Scalars['String']>;
  poolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not_starts_with?: InputMaybe<Scalars['String']>;
  poolId_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token0Price?: InputMaybe<Scalars['String']>;
  token0Price_contains?: InputMaybe<Scalars['String']>;
  token0Price_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not?: InputMaybe<Scalars['String']>;
  token0Price_not_contains?: InputMaybe<Scalars['String']>;
  token0Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Price_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Price?: InputMaybe<Scalars['String']>;
  token1Price_contains?: InputMaybe<Scalars['String']>;
  token1Price_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not?: InputMaybe<Scalars['String']>;
  token1Price_not_contains?: InputMaybe<Scalars['String']>;
  token1Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Price_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['BigInt']>;
  txCount_gt?: InputMaybe<Scalars['BigInt']>;
  txCount_gte?: InputMaybe<Scalars['BigInt']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  txCount_lt?: InputMaybe<Scalars['BigInt']>;
  txCount_lte?: InputMaybe<Scalars['BigInt']>;
  txCount_not?: InputMaybe<Scalars['BigInt']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0?: InputMaybe<Scalars['String']>;
  volumeToken0_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not?: InputMaybe<Scalars['String']>;
  volumeToken0_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1?: InputMaybe<Scalars['String']>;
  volumeToken1_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not?: InputMaybe<Scalars['String']>;
  volumeToken1_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type V3PoolDayDataPage = {
  __typename?: 'v3PoolDayDataPage';
  items: Array<V3PoolDayData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type V3PoolFilter = {
  AND?: InputMaybe<Array<InputMaybe<V3PoolFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<V3PoolFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  chain?: InputMaybe<Chain>;
  chain_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  chain_not?: InputMaybe<Chain>;
  chain_not_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  collectedFeesToken0?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_contains?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesToken0_not?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_not_contains?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_starts_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken1?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_contains?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesToken1_not?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_not_contains?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_starts_with?: InputMaybe<Scalars['String']>;
  collectedFeesUSD?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_contains?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesUSD_not?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_not_contains?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_starts_with?: InputMaybe<Scalars['String']>;
  createdAtBlockNumber?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_gt?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_gte?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAtBlockNumber_lt?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_lte?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_not?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAtTimestamp?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_gt?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_gte?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAtTimestamp_lt?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_lte?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_not?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  feeTier?: InputMaybe<Scalars['Int']>;
  feeTier_gt?: InputMaybe<Scalars['Int']>;
  feeTier_gte?: InputMaybe<Scalars['Int']>;
  feeTier_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  feeTier_lt?: InputMaybe<Scalars['Int']>;
  feeTier_lte?: InputMaybe<Scalars['Int']>;
  feeTier_not?: InputMaybe<Scalars['Int']>;
  feeTier_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  indexText?: InputMaybe<Scalars['String']>;
  indexText_contains?: InputMaybe<Scalars['String']>;
  indexText_ends_with?: InputMaybe<Scalars['String']>;
  indexText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexText_not?: InputMaybe<Scalars['String']>;
  indexText_not_contains?: InputMaybe<Scalars['String']>;
  indexText_not_ends_with?: InputMaybe<Scalars['String']>;
  indexText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexText_not_starts_with?: InputMaybe<Scalars['String']>;
  indexText_starts_with?: InputMaybe<Scalars['String']>;
  liquidity?: InputMaybe<Scalars['String']>;
  liquidityProviderCount?: InputMaybe<Scalars['String']>;
  liquidityProviderCount_contains?: InputMaybe<Scalars['String']>;
  liquidityProviderCount_ends_with?: InputMaybe<Scalars['String']>;
  liquidityProviderCount_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  liquidityProviderCount_not?: InputMaybe<Scalars['String']>;
  liquidityProviderCount_not_contains?: InputMaybe<Scalars['String']>;
  liquidityProviderCount_not_ends_with?: InputMaybe<Scalars['String']>;
  liquidityProviderCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  liquidityProviderCount_not_starts_with?: InputMaybe<Scalars['String']>;
  liquidityProviderCount_starts_with?: InputMaybe<Scalars['String']>;
  liquidity_contains?: InputMaybe<Scalars['String']>;
  liquidity_ends_with?: InputMaybe<Scalars['String']>;
  liquidity_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  liquidity_not?: InputMaybe<Scalars['String']>;
  liquidity_not_contains?: InputMaybe<Scalars['String']>;
  liquidity_not_ends_with?: InputMaybe<Scalars['String']>;
  liquidity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  liquidity_not_starts_with?: InputMaybe<Scalars['String']>;
  liquidity_starts_with?: InputMaybe<Scalars['String']>;
  observationIndex?: InputMaybe<Scalars['BigInt']>;
  observationIndex_gt?: InputMaybe<Scalars['BigInt']>;
  observationIndex_gte?: InputMaybe<Scalars['BigInt']>;
  observationIndex_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  observationIndex_lt?: InputMaybe<Scalars['BigInt']>;
  observationIndex_lte?: InputMaybe<Scalars['BigInt']>;
  observationIndex_not?: InputMaybe<Scalars['BigInt']>;
  observationIndex_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  sqrtPrice?: InputMaybe<Scalars['String']>;
  sqrtPrice_contains?: InputMaybe<Scalars['String']>;
  sqrtPrice_ends_with?: InputMaybe<Scalars['String']>;
  sqrtPrice_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sqrtPrice_not?: InputMaybe<Scalars['String']>;
  sqrtPrice_not_contains?: InputMaybe<Scalars['String']>;
  sqrtPrice_not_ends_with?: InputMaybe<Scalars['String']>;
  sqrtPrice_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sqrtPrice_not_starts_with?: InputMaybe<Scalars['String']>;
  sqrtPrice_starts_with?: InputMaybe<Scalars['String']>;
  tick?: InputMaybe<Scalars['Int']>;
  tick_gt?: InputMaybe<Scalars['Int']>;
  tick_gte?: InputMaybe<Scalars['Int']>;
  tick_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tick_lt?: InputMaybe<Scalars['Int']>;
  tick_lte?: InputMaybe<Scalars['Int']>;
  tick_not?: InputMaybe<Scalars['Int']>;
  tick_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token0Price?: InputMaybe<Scalars['String']>;
  token0Price_contains?: InputMaybe<Scalars['String']>;
  token0Price_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not?: InputMaybe<Scalars['String']>;
  token0Price_not_contains?: InputMaybe<Scalars['String']>;
  token0Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Price_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Price?: InputMaybe<Scalars['String']>;
  token1Price_contains?: InputMaybe<Scalars['String']>;
  token1Price_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not?: InputMaybe<Scalars['String']>;
  token1Price_not_contains?: InputMaybe<Scalars['String']>;
  token1Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Price_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedETH_not?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedETH_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedToken0_not?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedToken1_not?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSDUntracked_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSDUntracked_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['Int']>;
  txCount_gt?: InputMaybe<Scalars['Int']>;
  txCount_gte?: InputMaybe<Scalars['Int']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  txCount_lt?: InputMaybe<Scalars['Int']>;
  txCount_lte?: InputMaybe<Scalars['Int']>;
  txCount_not?: InputMaybe<Scalars['Int']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0?: InputMaybe<Scalars['String']>;
  volumeToken0_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not?: InputMaybe<Scalars['String']>;
  volumeToken0_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1?: InputMaybe<Scalars['String']>;
  volumeToken1_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not?: InputMaybe<Scalars['String']>;
  volumeToken1_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type V3PoolHourData = {
  __typename?: 'v3PoolHourData';
  address: Scalars['String'];
  close: Scalars['String'];
  date: Scalars['BigInt'];
  dayId: Scalars['BigInt'];
  feesUSD: Scalars['String'];
  high: Scalars['String'];
  id: Scalars['String'];
  low: Scalars['String'];
  open: Scalars['String'];
  pool?: Maybe<V3Pool>;
  poolId: Scalars['String'];
  protocolVersion: ProtocolVersion;
  token0Id: Scalars['String'];
  token0Price: Scalars['String'];
  token1Id: Scalars['String'];
  token1Price: Scalars['String'];
  txCount: Scalars['BigInt'];
  untrackedVolumeUSD: Scalars['String'];
  volumeToken0: Scalars['String'];
  volumeToken1: Scalars['String'];
  volumeUSD: Scalars['String'];
};

export type V3PoolHourDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<V3PoolHourDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<V3PoolHourDataFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  close?: InputMaybe<Scalars['String']>;
  close_contains?: InputMaybe<Scalars['String']>;
  close_ends_with?: InputMaybe<Scalars['String']>;
  close_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not?: InputMaybe<Scalars['String']>;
  close_not_contains?: InputMaybe<Scalars['String']>;
  close_not_ends_with?: InputMaybe<Scalars['String']>;
  close_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not_starts_with?: InputMaybe<Scalars['String']>;
  close_starts_with?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['BigInt']>;
  date_gt?: InputMaybe<Scalars['BigInt']>;
  date_gte?: InputMaybe<Scalars['BigInt']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  date_lt?: InputMaybe<Scalars['BigInt']>;
  date_lte?: InputMaybe<Scalars['BigInt']>;
  date_not?: InputMaybe<Scalars['BigInt']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId?: InputMaybe<Scalars['BigInt']>;
  dayId_gt?: InputMaybe<Scalars['BigInt']>;
  dayId_gte?: InputMaybe<Scalars['BigInt']>;
  dayId_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId_lt?: InputMaybe<Scalars['BigInt']>;
  dayId_lte?: InputMaybe<Scalars['BigInt']>;
  dayId_not?: InputMaybe<Scalars['BigInt']>;
  dayId_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['String']>;
  high_contains?: InputMaybe<Scalars['String']>;
  high_ends_with?: InputMaybe<Scalars['String']>;
  high_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not?: InputMaybe<Scalars['String']>;
  high_not_contains?: InputMaybe<Scalars['String']>;
  high_not_ends_with?: InputMaybe<Scalars['String']>;
  high_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not_starts_with?: InputMaybe<Scalars['String']>;
  high_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  low?: InputMaybe<Scalars['String']>;
  low_contains?: InputMaybe<Scalars['String']>;
  low_ends_with?: InputMaybe<Scalars['String']>;
  low_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not?: InputMaybe<Scalars['String']>;
  low_not_contains?: InputMaybe<Scalars['String']>;
  low_not_ends_with?: InputMaybe<Scalars['String']>;
  low_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not_starts_with?: InputMaybe<Scalars['String']>;
  low_starts_with?: InputMaybe<Scalars['String']>;
  open?: InputMaybe<Scalars['String']>;
  open_contains?: InputMaybe<Scalars['String']>;
  open_ends_with?: InputMaybe<Scalars['String']>;
  open_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not?: InputMaybe<Scalars['String']>;
  open_not_contains?: InputMaybe<Scalars['String']>;
  open_not_ends_with?: InputMaybe<Scalars['String']>;
  open_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not_starts_with?: InputMaybe<Scalars['String']>;
  open_starts_with?: InputMaybe<Scalars['String']>;
  poolId?: InputMaybe<Scalars['String']>;
  poolId_contains?: InputMaybe<Scalars['String']>;
  poolId_ends_with?: InputMaybe<Scalars['String']>;
  poolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not?: InputMaybe<Scalars['String']>;
  poolId_not_contains?: InputMaybe<Scalars['String']>;
  poolId_not_ends_with?: InputMaybe<Scalars['String']>;
  poolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not_starts_with?: InputMaybe<Scalars['String']>;
  poolId_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token0Price?: InputMaybe<Scalars['String']>;
  token0Price_contains?: InputMaybe<Scalars['String']>;
  token0Price_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not?: InputMaybe<Scalars['String']>;
  token0Price_not_contains?: InputMaybe<Scalars['String']>;
  token0Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Price_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Price?: InputMaybe<Scalars['String']>;
  token1Price_contains?: InputMaybe<Scalars['String']>;
  token1Price_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not?: InputMaybe<Scalars['String']>;
  token1Price_not_contains?: InputMaybe<Scalars['String']>;
  token1Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Price_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['BigInt']>;
  txCount_gt?: InputMaybe<Scalars['BigInt']>;
  txCount_gte?: InputMaybe<Scalars['BigInt']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  txCount_lt?: InputMaybe<Scalars['BigInt']>;
  txCount_lte?: InputMaybe<Scalars['BigInt']>;
  txCount_not?: InputMaybe<Scalars['BigInt']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0?: InputMaybe<Scalars['String']>;
  volumeToken0_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not?: InputMaybe<Scalars['String']>;
  volumeToken0_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1?: InputMaybe<Scalars['String']>;
  volumeToken1_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not?: InputMaybe<Scalars['String']>;
  volumeToken1_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type V3PoolHourDataPage = {
  __typename?: 'v3PoolHourDataPage';
  items: Array<V3PoolHourData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type V3PoolPage = {
  __typename?: 'v3PoolPage';
  items: Array<V3Pool>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type V4Pool = {
  __typename?: 'v4Pool';
  chain: Chain;
  collectedFeesToken0: Scalars['String'];
  collectedFeesToken1: Scalars['String'];
  collectedFeesUSD: Scalars['String'];
  createdAtBlockNumber: Scalars['BigInt'];
  createdAtTimestamp: Scalars['BigInt'];
  dayData?: Maybe<V4PoolDayDataPage>;
  feeTier: Scalars['Int'];
  feesUSD: Scalars['String'];
  hooks: Scalars['String'];
  hourData?: Maybe<V4PoolHourDataPage>;
  id: Scalars['String'];
  indexText: Scalars['String'];
  liquidity: Scalars['String'];
  liquidityProviderCount: Scalars['BigInt'];
  observationIndex: Scalars['BigInt'];
  poolId: Scalars['String'];
  protocolVersion: ProtocolVersion;
  sqrtPrice: Scalars['String'];
  tick: Scalars['Int'];
  tickSpacing: Scalars['Int'];
  token0?: Maybe<Token>;
  token0Id: Scalars['String'];
  token0Price: Scalars['String'];
  token1?: Maybe<Token>;
  token1Id: Scalars['String'];
  token1Price: Scalars['String'];
  totalValueLockedETH: Scalars['String'];
  totalValueLockedToken0: Scalars['String'];
  totalValueLockedToken1: Scalars['String'];
  totalValueLockedUSD: Scalars['String'];
  totalValueLockedUSDUntracked: Scalars['String'];
  txCount: Scalars['BigInt'];
  untrackedVolumeUSD: Scalars['String'];
  volumeToken0: Scalars['String'];
  volumeToken1: Scalars['String'];
  volumeUSD: Scalars['String'];
};


export type V4PoolDayDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V4PoolDayDataFilter>;
};


export type V4PoolHourDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<V4PoolHourDataFilter>;
};

export type V4PoolDayData = {
  __typename?: 'v4PoolDayData';
  address: Scalars['String'];
  close: Scalars['String'];
  date?: Maybe<Scalars['BigInt']>;
  dayId: Scalars['BigInt'];
  feesUSD: Scalars['String'];
  high: Scalars['String'];
  id: Scalars['String'];
  low: Scalars['String'];
  open: Scalars['String'];
  pool?: Maybe<V4Pool>;
  poolId: Scalars['String'];
  protocolVersion: ProtocolVersion;
  token0Id: Scalars['String'];
  token0Price: Scalars['String'];
  token1Id: Scalars['String'];
  token1Price: Scalars['String'];
  txCount: Scalars['BigInt'];
  untrackedVolumeUSD: Scalars['String'];
  volumeToken0: Scalars['String'];
  volumeToken1: Scalars['String'];
  volumeUSD: Scalars['String'];
};

export type V4PoolDayDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<V4PoolDayDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<V4PoolDayDataFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  close?: InputMaybe<Scalars['String']>;
  close_contains?: InputMaybe<Scalars['String']>;
  close_ends_with?: InputMaybe<Scalars['String']>;
  close_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not?: InputMaybe<Scalars['String']>;
  close_not_contains?: InputMaybe<Scalars['String']>;
  close_not_ends_with?: InputMaybe<Scalars['String']>;
  close_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not_starts_with?: InputMaybe<Scalars['String']>;
  close_starts_with?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['BigInt']>;
  date_gt?: InputMaybe<Scalars['BigInt']>;
  date_gte?: InputMaybe<Scalars['BigInt']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  date_lt?: InputMaybe<Scalars['BigInt']>;
  date_lte?: InputMaybe<Scalars['BigInt']>;
  date_not?: InputMaybe<Scalars['BigInt']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId?: InputMaybe<Scalars['BigInt']>;
  dayId_gt?: InputMaybe<Scalars['BigInt']>;
  dayId_gte?: InputMaybe<Scalars['BigInt']>;
  dayId_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId_lt?: InputMaybe<Scalars['BigInt']>;
  dayId_lte?: InputMaybe<Scalars['BigInt']>;
  dayId_not?: InputMaybe<Scalars['BigInt']>;
  dayId_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['String']>;
  high_contains?: InputMaybe<Scalars['String']>;
  high_ends_with?: InputMaybe<Scalars['String']>;
  high_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not?: InputMaybe<Scalars['String']>;
  high_not_contains?: InputMaybe<Scalars['String']>;
  high_not_ends_with?: InputMaybe<Scalars['String']>;
  high_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not_starts_with?: InputMaybe<Scalars['String']>;
  high_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  low?: InputMaybe<Scalars['String']>;
  low_contains?: InputMaybe<Scalars['String']>;
  low_ends_with?: InputMaybe<Scalars['String']>;
  low_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not?: InputMaybe<Scalars['String']>;
  low_not_contains?: InputMaybe<Scalars['String']>;
  low_not_ends_with?: InputMaybe<Scalars['String']>;
  low_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not_starts_with?: InputMaybe<Scalars['String']>;
  low_starts_with?: InputMaybe<Scalars['String']>;
  open?: InputMaybe<Scalars['String']>;
  open_contains?: InputMaybe<Scalars['String']>;
  open_ends_with?: InputMaybe<Scalars['String']>;
  open_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not?: InputMaybe<Scalars['String']>;
  open_not_contains?: InputMaybe<Scalars['String']>;
  open_not_ends_with?: InputMaybe<Scalars['String']>;
  open_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not_starts_with?: InputMaybe<Scalars['String']>;
  open_starts_with?: InputMaybe<Scalars['String']>;
  poolId?: InputMaybe<Scalars['String']>;
  poolId_contains?: InputMaybe<Scalars['String']>;
  poolId_ends_with?: InputMaybe<Scalars['String']>;
  poolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not?: InputMaybe<Scalars['String']>;
  poolId_not_contains?: InputMaybe<Scalars['String']>;
  poolId_not_ends_with?: InputMaybe<Scalars['String']>;
  poolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not_starts_with?: InputMaybe<Scalars['String']>;
  poolId_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token0Price?: InputMaybe<Scalars['String']>;
  token0Price_contains?: InputMaybe<Scalars['String']>;
  token0Price_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not?: InputMaybe<Scalars['String']>;
  token0Price_not_contains?: InputMaybe<Scalars['String']>;
  token0Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Price_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Price?: InputMaybe<Scalars['String']>;
  token1Price_contains?: InputMaybe<Scalars['String']>;
  token1Price_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not?: InputMaybe<Scalars['String']>;
  token1Price_not_contains?: InputMaybe<Scalars['String']>;
  token1Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Price_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['BigInt']>;
  txCount_gt?: InputMaybe<Scalars['BigInt']>;
  txCount_gte?: InputMaybe<Scalars['BigInt']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  txCount_lt?: InputMaybe<Scalars['BigInt']>;
  txCount_lte?: InputMaybe<Scalars['BigInt']>;
  txCount_not?: InputMaybe<Scalars['BigInt']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0?: InputMaybe<Scalars['String']>;
  volumeToken0_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not?: InputMaybe<Scalars['String']>;
  volumeToken0_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1?: InputMaybe<Scalars['String']>;
  volumeToken1_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not?: InputMaybe<Scalars['String']>;
  volumeToken1_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type V4PoolDayDataPage = {
  __typename?: 'v4PoolDayDataPage';
  items: Array<V4PoolDayData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type V4PoolFilter = {
  AND?: InputMaybe<Array<InputMaybe<V4PoolFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<V4PoolFilter>>>;
  chain?: InputMaybe<Chain>;
  chain_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  chain_not?: InputMaybe<Chain>;
  chain_not_in?: InputMaybe<Array<InputMaybe<Chain>>>;
  collectedFeesToken0?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_contains?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesToken0_not?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_not_contains?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken0_starts_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken1?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_contains?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesToken1_not?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_not_contains?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  collectedFeesToken1_starts_with?: InputMaybe<Scalars['String']>;
  collectedFeesUSD?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_contains?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesUSD_not?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_not_contains?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectedFeesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  collectedFeesUSD_starts_with?: InputMaybe<Scalars['String']>;
  createdAtBlockNumber?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_gt?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_gte?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAtBlockNumber_lt?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_lte?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_not?: InputMaybe<Scalars['BigInt']>;
  createdAtBlockNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAtTimestamp?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_gt?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_gte?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAtTimestamp_lt?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_lte?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_not?: InputMaybe<Scalars['BigInt']>;
  createdAtTimestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  feeTier?: InputMaybe<Scalars['Int']>;
  feeTier_gt?: InputMaybe<Scalars['Int']>;
  feeTier_gte?: InputMaybe<Scalars['Int']>;
  feeTier_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  feeTier_lt?: InputMaybe<Scalars['Int']>;
  feeTier_lte?: InputMaybe<Scalars['Int']>;
  feeTier_not?: InputMaybe<Scalars['Int']>;
  feeTier_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  hooks?: InputMaybe<Scalars['String']>;
  hooks_contains?: InputMaybe<Scalars['String']>;
  hooks_ends_with?: InputMaybe<Scalars['String']>;
  hooks_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hooks_not?: InputMaybe<Scalars['String']>;
  hooks_not_contains?: InputMaybe<Scalars['String']>;
  hooks_not_ends_with?: InputMaybe<Scalars['String']>;
  hooks_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hooks_not_starts_with?: InputMaybe<Scalars['String']>;
  hooks_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  indexText?: InputMaybe<Scalars['String']>;
  indexText_contains?: InputMaybe<Scalars['String']>;
  indexText_ends_with?: InputMaybe<Scalars['String']>;
  indexText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexText_not?: InputMaybe<Scalars['String']>;
  indexText_not_contains?: InputMaybe<Scalars['String']>;
  indexText_not_ends_with?: InputMaybe<Scalars['String']>;
  indexText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexText_not_starts_with?: InputMaybe<Scalars['String']>;
  indexText_starts_with?: InputMaybe<Scalars['String']>;
  liquidity?: InputMaybe<Scalars['String']>;
  liquidityProviderCount?: InputMaybe<Scalars['BigInt']>;
  liquidityProviderCount_gt?: InputMaybe<Scalars['BigInt']>;
  liquidityProviderCount_gte?: InputMaybe<Scalars['BigInt']>;
  liquidityProviderCount_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  liquidityProviderCount_lt?: InputMaybe<Scalars['BigInt']>;
  liquidityProviderCount_lte?: InputMaybe<Scalars['BigInt']>;
  liquidityProviderCount_not?: InputMaybe<Scalars['BigInt']>;
  liquidityProviderCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  liquidity_contains?: InputMaybe<Scalars['String']>;
  liquidity_ends_with?: InputMaybe<Scalars['String']>;
  liquidity_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  liquidity_not?: InputMaybe<Scalars['String']>;
  liquidity_not_contains?: InputMaybe<Scalars['String']>;
  liquidity_not_ends_with?: InputMaybe<Scalars['String']>;
  liquidity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  liquidity_not_starts_with?: InputMaybe<Scalars['String']>;
  liquidity_starts_with?: InputMaybe<Scalars['String']>;
  observationIndex?: InputMaybe<Scalars['BigInt']>;
  observationIndex_gt?: InputMaybe<Scalars['BigInt']>;
  observationIndex_gte?: InputMaybe<Scalars['BigInt']>;
  observationIndex_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  observationIndex_lt?: InputMaybe<Scalars['BigInt']>;
  observationIndex_lte?: InputMaybe<Scalars['BigInt']>;
  observationIndex_not?: InputMaybe<Scalars['BigInt']>;
  observationIndex_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  poolId?: InputMaybe<Scalars['String']>;
  poolId_contains?: InputMaybe<Scalars['String']>;
  poolId_ends_with?: InputMaybe<Scalars['String']>;
  poolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not?: InputMaybe<Scalars['String']>;
  poolId_not_contains?: InputMaybe<Scalars['String']>;
  poolId_not_ends_with?: InputMaybe<Scalars['String']>;
  poolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not_starts_with?: InputMaybe<Scalars['String']>;
  poolId_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  sqrtPrice?: InputMaybe<Scalars['String']>;
  sqrtPrice_contains?: InputMaybe<Scalars['String']>;
  sqrtPrice_ends_with?: InputMaybe<Scalars['String']>;
  sqrtPrice_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sqrtPrice_not?: InputMaybe<Scalars['String']>;
  sqrtPrice_not_contains?: InputMaybe<Scalars['String']>;
  sqrtPrice_not_ends_with?: InputMaybe<Scalars['String']>;
  sqrtPrice_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sqrtPrice_not_starts_with?: InputMaybe<Scalars['String']>;
  sqrtPrice_starts_with?: InputMaybe<Scalars['String']>;
  tick?: InputMaybe<Scalars['Int']>;
  tickSpacing?: InputMaybe<Scalars['Int']>;
  tickSpacing_gt?: InputMaybe<Scalars['Int']>;
  tickSpacing_gte?: InputMaybe<Scalars['Int']>;
  tickSpacing_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tickSpacing_lt?: InputMaybe<Scalars['Int']>;
  tickSpacing_lte?: InputMaybe<Scalars['Int']>;
  tickSpacing_not?: InputMaybe<Scalars['Int']>;
  tickSpacing_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tick_gt?: InputMaybe<Scalars['Int']>;
  tick_gte?: InputMaybe<Scalars['Int']>;
  tick_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tick_lt?: InputMaybe<Scalars['Int']>;
  tick_lte?: InputMaybe<Scalars['Int']>;
  tick_not?: InputMaybe<Scalars['Int']>;
  tick_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token0Price?: InputMaybe<Scalars['String']>;
  token0Price_contains?: InputMaybe<Scalars['String']>;
  token0Price_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not?: InputMaybe<Scalars['String']>;
  token0Price_not_contains?: InputMaybe<Scalars['String']>;
  token0Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Price_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Price?: InputMaybe<Scalars['String']>;
  token1Price_contains?: InputMaybe<Scalars['String']>;
  token1Price_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not?: InputMaybe<Scalars['String']>;
  token1Price_not_contains?: InputMaybe<Scalars['String']>;
  token1Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Price_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedETH_not?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedETH_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedETH_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedToken0_not?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken0_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedToken1_not?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedToken1_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSDUntracked_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSDUntracked_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSDUntracked_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_contains?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalValueLockedUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  totalValueLockedUSD_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['BigInt']>;
  txCount_gt?: InputMaybe<Scalars['BigInt']>;
  txCount_gte?: InputMaybe<Scalars['BigInt']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  txCount_lt?: InputMaybe<Scalars['BigInt']>;
  txCount_lte?: InputMaybe<Scalars['BigInt']>;
  txCount_not?: InputMaybe<Scalars['BigInt']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0?: InputMaybe<Scalars['String']>;
  volumeToken0_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not?: InputMaybe<Scalars['String']>;
  volumeToken0_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1?: InputMaybe<Scalars['String']>;
  volumeToken1_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not?: InputMaybe<Scalars['String']>;
  volumeToken1_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type V4PoolHourData = {
  __typename?: 'v4PoolHourData';
  address: Scalars['String'];
  close: Scalars['String'];
  date: Scalars['BigInt'];
  dayId: Scalars['BigInt'];
  feesUSD: Scalars['String'];
  high: Scalars['String'];
  id: Scalars['String'];
  low: Scalars['String'];
  open: Scalars['String'];
  pool?: Maybe<V4Pool>;
  poolId: Scalars['String'];
  protocolVersion: ProtocolVersion;
  token0Id: Scalars['String'];
  token0Price: Scalars['String'];
  token1Id: Scalars['String'];
  token1Price: Scalars['String'];
  txCount: Scalars['BigInt'];
  untrackedVolumeUSD: Scalars['String'];
  volumeToken0: Scalars['String'];
  volumeToken1: Scalars['String'];
  volumeUSD: Scalars['String'];
};

export type V4PoolHourDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<V4PoolHourDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<V4PoolHourDataFilter>>>;
  address?: InputMaybe<Scalars['String']>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  close?: InputMaybe<Scalars['String']>;
  close_contains?: InputMaybe<Scalars['String']>;
  close_ends_with?: InputMaybe<Scalars['String']>;
  close_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not?: InputMaybe<Scalars['String']>;
  close_not_contains?: InputMaybe<Scalars['String']>;
  close_not_ends_with?: InputMaybe<Scalars['String']>;
  close_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  close_not_starts_with?: InputMaybe<Scalars['String']>;
  close_starts_with?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['BigInt']>;
  date_gt?: InputMaybe<Scalars['BigInt']>;
  date_gte?: InputMaybe<Scalars['BigInt']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  date_lt?: InputMaybe<Scalars['BigInt']>;
  date_lte?: InputMaybe<Scalars['BigInt']>;
  date_not?: InputMaybe<Scalars['BigInt']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId?: InputMaybe<Scalars['BigInt']>;
  dayId_gt?: InputMaybe<Scalars['BigInt']>;
  dayId_gte?: InputMaybe<Scalars['BigInt']>;
  dayId_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  dayId_lt?: InputMaybe<Scalars['BigInt']>;
  dayId_lte?: InputMaybe<Scalars['BigInt']>;
  dayId_not?: InputMaybe<Scalars['BigInt']>;
  dayId_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  feesUSD?: InputMaybe<Scalars['String']>;
  feesUSD_contains?: InputMaybe<Scalars['String']>;
  feesUSD_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not?: InputMaybe<Scalars['String']>;
  feesUSD_not_contains?: InputMaybe<Scalars['String']>;
  feesUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  feesUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  feesUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  feesUSD_starts_with?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['String']>;
  high_contains?: InputMaybe<Scalars['String']>;
  high_ends_with?: InputMaybe<Scalars['String']>;
  high_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not?: InputMaybe<Scalars['String']>;
  high_not_contains?: InputMaybe<Scalars['String']>;
  high_not_ends_with?: InputMaybe<Scalars['String']>;
  high_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  high_not_starts_with?: InputMaybe<Scalars['String']>;
  high_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  low?: InputMaybe<Scalars['String']>;
  low_contains?: InputMaybe<Scalars['String']>;
  low_ends_with?: InputMaybe<Scalars['String']>;
  low_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not?: InputMaybe<Scalars['String']>;
  low_not_contains?: InputMaybe<Scalars['String']>;
  low_not_ends_with?: InputMaybe<Scalars['String']>;
  low_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  low_not_starts_with?: InputMaybe<Scalars['String']>;
  low_starts_with?: InputMaybe<Scalars['String']>;
  open?: InputMaybe<Scalars['String']>;
  open_contains?: InputMaybe<Scalars['String']>;
  open_ends_with?: InputMaybe<Scalars['String']>;
  open_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not?: InputMaybe<Scalars['String']>;
  open_not_contains?: InputMaybe<Scalars['String']>;
  open_not_ends_with?: InputMaybe<Scalars['String']>;
  open_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  open_not_starts_with?: InputMaybe<Scalars['String']>;
  open_starts_with?: InputMaybe<Scalars['String']>;
  poolId?: InputMaybe<Scalars['String']>;
  poolId_contains?: InputMaybe<Scalars['String']>;
  poolId_ends_with?: InputMaybe<Scalars['String']>;
  poolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not?: InputMaybe<Scalars['String']>;
  poolId_not_contains?: InputMaybe<Scalars['String']>;
  poolId_not_ends_with?: InputMaybe<Scalars['String']>;
  poolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poolId_not_starts_with?: InputMaybe<Scalars['String']>;
  poolId_starts_with?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<ProtocolVersion>;
  protocolVersion_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  protocolVersion_not?: InputMaybe<ProtocolVersion>;
  protocolVersion_not_in?: InputMaybe<Array<InputMaybe<ProtocolVersion>>>;
  token0Id?: InputMaybe<Scalars['String']>;
  token0Id_contains?: InputMaybe<Scalars['String']>;
  token0Id_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not?: InputMaybe<Scalars['String']>;
  token0Id_not_contains?: InputMaybe<Scalars['String']>;
  token0Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Id_starts_with?: InputMaybe<Scalars['String']>;
  token0Price?: InputMaybe<Scalars['String']>;
  token0Price_contains?: InputMaybe<Scalars['String']>;
  token0Price_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not?: InputMaybe<Scalars['String']>;
  token0Price_not_contains?: InputMaybe<Scalars['String']>;
  token0Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token0Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token0Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token0Price_starts_with?: InputMaybe<Scalars['String']>;
  token1Id?: InputMaybe<Scalars['String']>;
  token1Id_contains?: InputMaybe<Scalars['String']>;
  token1Id_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not?: InputMaybe<Scalars['String']>;
  token1Id_not_contains?: InputMaybe<Scalars['String']>;
  token1Id_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Id_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Id_starts_with?: InputMaybe<Scalars['String']>;
  token1Price?: InputMaybe<Scalars['String']>;
  token1Price_contains?: InputMaybe<Scalars['String']>;
  token1Price_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not?: InputMaybe<Scalars['String']>;
  token1Price_not_contains?: InputMaybe<Scalars['String']>;
  token1Price_not_ends_with?: InputMaybe<Scalars['String']>;
  token1Price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token1Price_not_starts_with?: InputMaybe<Scalars['String']>;
  token1Price_starts_with?: InputMaybe<Scalars['String']>;
  txCount?: InputMaybe<Scalars['BigInt']>;
  txCount_gt?: InputMaybe<Scalars['BigInt']>;
  txCount_gte?: InputMaybe<Scalars['BigInt']>;
  txCount_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  txCount_lt?: InputMaybe<Scalars['BigInt']>;
  txCount_lte?: InputMaybe<Scalars['BigInt']>;
  txCount_not?: InputMaybe<Scalars['BigInt']>;
  txCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  untrackedVolumeUSD?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  untrackedVolumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  untrackedVolumeUSD_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0?: InputMaybe<Scalars['String']>;
  volumeToken0_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not?: InputMaybe<Scalars['String']>;
  volumeToken0_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken0_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken0_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken0_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken0_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1?: InputMaybe<Scalars['String']>;
  volumeToken1_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not?: InputMaybe<Scalars['String']>;
  volumeToken1_not_contains?: InputMaybe<Scalars['String']>;
  volumeToken1_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeToken1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeToken1_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeToken1_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD?: InputMaybe<Scalars['String']>;
  volumeUSD_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not?: InputMaybe<Scalars['String']>;
  volumeUSD_not_contains?: InputMaybe<Scalars['String']>;
  volumeUSD_not_ends_with?: InputMaybe<Scalars['String']>;
  volumeUSD_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeUSD_not_starts_with?: InputMaybe<Scalars['String']>;
  volumeUSD_starts_with?: InputMaybe<Scalars['String']>;
};

export type V4PoolHourDataPage = {
  __typename?: 'v4PoolHourDataPage';
  items: Array<V4PoolHourData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type V4PoolPage = {
  __typename?: 'v4PoolPage';
  items: Array<V4Pool>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  BigInt: ResolverTypeWrapper<Scalars['BigInt']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  Meta: ResolverTypeWrapper<Meta>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']>;
  ViewPageInfo: ResolverTypeWrapper<ViewPageInfo>;
  chain: Chain;
  dailyProtocolTvl: ResolverTypeWrapper<DailyProtocolTvl>;
  dailyProtocolTvlFilter: DailyProtocolTvlFilter;
  dailyProtocolTvlPage: ResolverTypeWrapper<DailyProtocolTvlPage>;
  factory: ResolverTypeWrapper<Factory>;
  factoryDayData: ResolverTypeWrapper<FactoryDayData>;
  factoryDayDataFilter: FactoryDayDataFilter;
  factoryDayDataPage: ResolverTypeWrapper<FactoryDayDataPage>;
  factoryFilter: FactoryFilter;
  factoryHourData: ResolverTypeWrapper<FactoryHourData>;
  factoryHourDataFilter: FactoryHourDataFilter;
  factoryHourDataPage: ResolverTypeWrapper<FactoryHourDataPage>;
  factoryPage: ResolverTypeWrapper<FactoryPage>;
  feeData: ResolverTypeWrapper<FeeData>;
  feeDataFilter: FeeDataFilter;
  feeDataPage: ResolverTypeWrapper<FeeDataPage>;
  historicalProtocolVolume: ResolverTypeWrapper<HistoricalProtocolVolume>;
  historicalProtocolVolumeFilter: HistoricalProtocolVolumeFilter;
  historicalProtocolVolumePage: ResolverTypeWrapper<HistoricalProtocolVolumePage>;
  historicalTvl: ResolverTypeWrapper<HistoricalTvl>;
  historicalTvlFilter: HistoricalTvlFilter;
  historicalTvlPage: ResolverTypeWrapper<HistoricalTvlPage>;
  historicalVolume: ResolverTypeWrapper<HistoricalVolume>;
  historicalVolumeFilter: HistoricalVolumeFilter;
  historicalVolumePage: ResolverTypeWrapper<HistoricalVolumePage>;
  originToken: ResolverTypeWrapper<OriginToken>;
  originTokenFilter: OriginTokenFilter;
  originTokenPage: ResolverTypeWrapper<OriginTokenPage>;
  pairHistoricalVolume: ResolverTypeWrapper<PairHistoricalVolume>;
  pairHistoricalVolumeFilter: PairHistoricalVolumeFilter;
  pairHistoricalVolumePage: ResolverTypeWrapper<PairHistoricalVolumePage>;
  poolTransaction: ResolverTypeWrapper<PoolTransaction>;
  poolTransactionFilter: PoolTransactionFilter;
  poolTransactionPage: ResolverTypeWrapper<PoolTransactionPage>;
  poolTransactionType: PoolTransactionType;
  position: ResolverTypeWrapper<Position>;
  positionFilter: PositionFilter;
  positionPage: ResolverTypeWrapper<PositionPage>;
  priceHistory: ResolverTypeWrapper<PriceHistory>;
  priceHistoryFilter: PriceHistoryFilter;
  priceHistoryPage: ResolverTypeWrapper<PriceHistoryPage>;
  priceSource: PriceSource;
  protocolVersion: ProtocolVersion;
  standard: Standard;
  timestampedOhlc: ResolverTypeWrapper<TimestampedOhlc>;
  timestampedOhlcFilter: TimestampedOhlcFilter;
  timestampedOhlcPage: ResolverTypeWrapper<TimestampedOhlcPage>;
  token: ResolverTypeWrapper<Token>;
  tokenDayData: ResolverTypeWrapper<TokenDayData>;
  tokenDayDataFilter: TokenDayDataFilter;
  tokenDayDataPage: ResolverTypeWrapper<TokenDayDataPage>;
  tokenFilter: TokenFilter;
  tokenHourData: ResolverTypeWrapper<TokenHourData>;
  tokenHourDataFilter: TokenHourDataFilter;
  tokenHourDataPage: ResolverTypeWrapper<TokenHourDataPage>;
  tokenMarket: ResolverTypeWrapper<TokenMarket>;
  tokenMarketFilter: TokenMarketFilter;
  tokenMarketPage: ResolverTypeWrapper<TokenMarketPage>;
  tokenPage: ResolverTypeWrapper<TokenPage>;
  user: ResolverTypeWrapper<User>;
  userFilter: UserFilter;
  userPage: ResolverTypeWrapper<UserPage>;
  v2Pair: ResolverTypeWrapper<V2Pair>;
  v2PairDayData: ResolverTypeWrapper<V2PairDayData>;
  v2PairDayDataFilter: V2PairDayDataFilter;
  v2PairDayDataPage: ResolverTypeWrapper<V2PairDayDataPage>;
  v2PairFilter: V2PairFilter;
  v2PairHourData: ResolverTypeWrapper<V2PairHourData>;
  v2PairHourDataFilter: V2PairHourDataFilter;
  v2PairHourDataPage: ResolverTypeWrapper<V2PairHourDataPage>;
  v2PairPage: ResolverTypeWrapper<V2PairPage>;
  v2PairPriceHistory: ResolverTypeWrapper<V2PairPriceHistory>;
  v2PairPriceHistoryFilter: V2PairPriceHistoryFilter;
  v2PairPriceHistoryPage: ResolverTypeWrapper<V2PairPriceHistoryPage>;
  v3Pool: ResolverTypeWrapper<V3Pool>;
  v3PoolDayData: ResolverTypeWrapper<V3PoolDayData>;
  v3PoolDayDataFilter: V3PoolDayDataFilter;
  v3PoolDayDataPage: ResolverTypeWrapper<V3PoolDayDataPage>;
  v3PoolFilter: V3PoolFilter;
  v3PoolHourData: ResolverTypeWrapper<V3PoolHourData>;
  v3PoolHourDataFilter: V3PoolHourDataFilter;
  v3PoolHourDataPage: ResolverTypeWrapper<V3PoolHourDataPage>;
  v3PoolPage: ResolverTypeWrapper<V3PoolPage>;
  v4Pool: ResolverTypeWrapper<V4Pool>;
  v4PoolDayData: ResolverTypeWrapper<V4PoolDayData>;
  v4PoolDayDataFilter: V4PoolDayDataFilter;
  v4PoolDayDataPage: ResolverTypeWrapper<V4PoolDayDataPage>;
  v4PoolFilter: V4PoolFilter;
  v4PoolHourData: ResolverTypeWrapper<V4PoolHourData>;
  v4PoolHourDataFilter: V4PoolHourDataFilter;
  v4PoolHourDataPage: ResolverTypeWrapper<V4PoolHourDataPage>;
  v4PoolPage: ResolverTypeWrapper<V4PoolPage>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  BigInt: Scalars['BigInt'];
  Boolean: Scalars['Boolean'];
  Float: Scalars['Float'];
  Int: Scalars['Int'];
  JSON: Scalars['JSON'];
  Meta: Meta;
  PageInfo: PageInfo;
  Query: {};
  String: Scalars['String'];
  ViewPageInfo: ViewPageInfo;
  dailyProtocolTvl: DailyProtocolTvl;
  dailyProtocolTvlFilter: DailyProtocolTvlFilter;
  dailyProtocolTvlPage: DailyProtocolTvlPage;
  factory: Factory;
  factoryDayData: FactoryDayData;
  factoryDayDataFilter: FactoryDayDataFilter;
  factoryDayDataPage: FactoryDayDataPage;
  factoryFilter: FactoryFilter;
  factoryHourData: FactoryHourData;
  factoryHourDataFilter: FactoryHourDataFilter;
  factoryHourDataPage: FactoryHourDataPage;
  factoryPage: FactoryPage;
  feeData: FeeData;
  feeDataFilter: FeeDataFilter;
  feeDataPage: FeeDataPage;
  historicalProtocolVolume: HistoricalProtocolVolume;
  historicalProtocolVolumeFilter: HistoricalProtocolVolumeFilter;
  historicalProtocolVolumePage: HistoricalProtocolVolumePage;
  historicalTvl: HistoricalTvl;
  historicalTvlFilter: HistoricalTvlFilter;
  historicalTvlPage: HistoricalTvlPage;
  historicalVolume: HistoricalVolume;
  historicalVolumeFilter: HistoricalVolumeFilter;
  historicalVolumePage: HistoricalVolumePage;
  originToken: OriginToken;
  originTokenFilter: OriginTokenFilter;
  originTokenPage: OriginTokenPage;
  pairHistoricalVolume: PairHistoricalVolume;
  pairHistoricalVolumeFilter: PairHistoricalVolumeFilter;
  pairHistoricalVolumePage: PairHistoricalVolumePage;
  poolTransaction: PoolTransaction;
  poolTransactionFilter: PoolTransactionFilter;
  poolTransactionPage: PoolTransactionPage;
  position: Position;
  positionFilter: PositionFilter;
  positionPage: PositionPage;
  priceHistory: PriceHistory;
  priceHistoryFilter: PriceHistoryFilter;
  priceHistoryPage: PriceHistoryPage;
  timestampedOhlc: TimestampedOhlc;
  timestampedOhlcFilter: TimestampedOhlcFilter;
  timestampedOhlcPage: TimestampedOhlcPage;
  token: Token;
  tokenDayData: TokenDayData;
  tokenDayDataFilter: TokenDayDataFilter;
  tokenDayDataPage: TokenDayDataPage;
  tokenFilter: TokenFilter;
  tokenHourData: TokenHourData;
  tokenHourDataFilter: TokenHourDataFilter;
  tokenHourDataPage: TokenHourDataPage;
  tokenMarket: TokenMarket;
  tokenMarketFilter: TokenMarketFilter;
  tokenMarketPage: TokenMarketPage;
  tokenPage: TokenPage;
  user: User;
  userFilter: UserFilter;
  userPage: UserPage;
  v2Pair: V2Pair;
  v2PairDayData: V2PairDayData;
  v2PairDayDataFilter: V2PairDayDataFilter;
  v2PairDayDataPage: V2PairDayDataPage;
  v2PairFilter: V2PairFilter;
  v2PairHourData: V2PairHourData;
  v2PairHourDataFilter: V2PairHourDataFilter;
  v2PairHourDataPage: V2PairHourDataPage;
  v2PairPage: V2PairPage;
  v2PairPriceHistory: V2PairPriceHistory;
  v2PairPriceHistoryFilter: V2PairPriceHistoryFilter;
  v2PairPriceHistoryPage: V2PairPriceHistoryPage;
  v3Pool: V3Pool;
  v3PoolDayData: V3PoolDayData;
  v3PoolDayDataFilter: V3PoolDayDataFilter;
  v3PoolDayDataPage: V3PoolDayDataPage;
  v3PoolFilter: V3PoolFilter;
  v3PoolHourData: V3PoolHourData;
  v3PoolHourDataFilter: V3PoolHourDataFilter;
  v3PoolHourDataPage: V3PoolHourDataPage;
  v3PoolPage: V3PoolPage;
  v4Pool: V4Pool;
  v4PoolDayData: V4PoolDayData;
  v4PoolDayDataFilter: V4PoolDayDataFilter;
  v4PoolDayDataPage: V4PoolDayDataPage;
  v4PoolFilter: V4PoolFilter;
  v4PoolHourData: V4PoolHourData;
  v4PoolHourDataFilter: V4PoolHourDataFilter;
  v4PoolHourDataPage: V4PoolHourDataPage;
  v4PoolPage: V4PoolPage;
};

export interface BigIntScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigInt'], any> {
  name: 'BigInt';
}

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type MetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['Meta'] = ResolversParentTypes['Meta']> = {
  status?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  _meta?: Resolver<Maybe<ResolversTypes['Meta']>, ParentType, ContextType>;
  dailyProtocolTvl?: Resolver<Maybe<ResolversTypes['dailyProtocolTvl']>, ParentType, ContextType, RequireFields<QueryDailyProtocolTvlArgs, 'id'>>;
  dailyProtocolTvls?: Resolver<ResolversTypes['dailyProtocolTvlPage'], ParentType, ContextType, Partial<QueryDailyProtocolTvlsArgs>>;
  factory?: Resolver<Maybe<ResolversTypes['factory']>, ParentType, ContextType, RequireFields<QueryFactoryArgs, 'id'>>;
  factoryDayData?: Resolver<Maybe<ResolversTypes['factoryDayData']>, ParentType, ContextType, RequireFields<QueryFactoryDayDataArgs, 'id'>>;
  factoryDayDatas?: Resolver<ResolversTypes['factoryDayDataPage'], ParentType, ContextType, Partial<QueryFactoryDayDatasArgs>>;
  factoryHourData?: Resolver<Maybe<ResolversTypes['factoryHourData']>, ParentType, ContextType, RequireFields<QueryFactoryHourDataArgs, 'id'>>;
  factoryHourDatas?: Resolver<ResolversTypes['factoryHourDataPage'], ParentType, ContextType, Partial<QueryFactoryHourDatasArgs>>;
  factorys?: Resolver<ResolversTypes['factoryPage'], ParentType, ContextType, Partial<QueryFactorysArgs>>;
  feeData?: Resolver<Maybe<ResolversTypes['feeData']>, ParentType, ContextType, RequireFields<QueryFeeDataArgs, 'id'>>;
  feeDatas?: Resolver<ResolversTypes['feeDataPage'], ParentType, ContextType, Partial<QueryFeeDatasArgs>>;
  historicalProtocolVolume?: Resolver<Maybe<ResolversTypes['historicalProtocolVolume']>, ParentType, ContextType, RequireFields<QueryHistoricalProtocolVolumeArgs, 'id'>>;
  historicalProtocolVolumes?: Resolver<ResolversTypes['historicalProtocolVolumePage'], ParentType, ContextType, Partial<QueryHistoricalProtocolVolumesArgs>>;
  historicalTvl?: Resolver<Maybe<ResolversTypes['historicalTvl']>, ParentType, ContextType, RequireFields<QueryHistoricalTvlArgs, 'id'>>;
  historicalTvls?: Resolver<ResolversTypes['historicalTvlPage'], ParentType, ContextType, Partial<QueryHistoricalTvlsArgs>>;
  historicalVolume?: Resolver<Maybe<ResolversTypes['historicalVolume']>, ParentType, ContextType, RequireFields<QueryHistoricalVolumeArgs, 'id'>>;
  historicalVolumes?: Resolver<ResolversTypes['historicalVolumePage'], ParentType, ContextType, Partial<QueryHistoricalVolumesArgs>>;
  originToken?: Resolver<Maybe<ResolversTypes['originToken']>, ParentType, ContextType, RequireFields<QueryOriginTokenArgs, 'id'>>;
  originTokens?: Resolver<ResolversTypes['originTokenPage'], ParentType, ContextType, Partial<QueryOriginTokensArgs>>;
  pairHistoricalVolume?: Resolver<Maybe<ResolversTypes['pairHistoricalVolume']>, ParentType, ContextType, RequireFields<QueryPairHistoricalVolumeArgs, 'id'>>;
  pairHistoricalVolumes?: Resolver<ResolversTypes['pairHistoricalVolumePage'], ParentType, ContextType, Partial<QueryPairHistoricalVolumesArgs>>;
  poolTransaction?: Resolver<Maybe<ResolversTypes['poolTransaction']>, ParentType, ContextType, RequireFields<QueryPoolTransactionArgs, 'id'>>;
  poolTransactions?: Resolver<ResolversTypes['poolTransactionPage'], ParentType, ContextType, Partial<QueryPoolTransactionsArgs>>;
  position?: Resolver<Maybe<ResolversTypes['position']>, ParentType, ContextType, RequireFields<QueryPositionArgs, 'id'>>;
  positions?: Resolver<ResolversTypes['positionPage'], ParentType, ContextType, Partial<QueryPositionsArgs>>;
  priceHistory?: Resolver<Maybe<ResolversTypes['priceHistory']>, ParentType, ContextType, RequireFields<QueryPriceHistoryArgs, 'id'>>;
  priceHistorys?: Resolver<ResolversTypes['priceHistoryPage'], ParentType, ContextType, Partial<QueryPriceHistorysArgs>>;
  timestampedOhlc?: Resolver<Maybe<ResolversTypes['timestampedOhlc']>, ParentType, ContextType, RequireFields<QueryTimestampedOhlcArgs, 'id'>>;
  timestampedOhlcs?: Resolver<ResolversTypes['timestampedOhlcPage'], ParentType, ContextType, Partial<QueryTimestampedOhlcsArgs>>;
  token?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType, RequireFields<QueryTokenArgs, 'id'>>;
  tokenDayData?: Resolver<Maybe<ResolversTypes['tokenDayData']>, ParentType, ContextType, RequireFields<QueryTokenDayDataArgs, 'id'>>;
  tokenDayDatas?: Resolver<ResolversTypes['tokenDayDataPage'], ParentType, ContextType, Partial<QueryTokenDayDatasArgs>>;
  tokenHourData?: Resolver<Maybe<ResolversTypes['tokenHourData']>, ParentType, ContextType, RequireFields<QueryTokenHourDataArgs, 'id'>>;
  tokenHourDatas?: Resolver<ResolversTypes['tokenHourDataPage'], ParentType, ContextType, Partial<QueryTokenHourDatasArgs>>;
  tokenMarket?: Resolver<Maybe<ResolversTypes['tokenMarket']>, ParentType, ContextType, RequireFields<QueryTokenMarketArgs, 'id'>>;
  tokenMarkets?: Resolver<ResolversTypes['tokenMarketPage'], ParentType, ContextType, Partial<QueryTokenMarketsArgs>>;
  tokens?: Resolver<ResolversTypes['tokenPage'], ParentType, ContextType, Partial<QueryTokensArgs>>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType, RequireFields<QueryUserArgs, 'id'>>;
  users?: Resolver<ResolversTypes['userPage'], ParentType, ContextType, Partial<QueryUsersArgs>>;
  v2Pair?: Resolver<Maybe<ResolversTypes['v2Pair']>, ParentType, ContextType, RequireFields<QueryV2PairArgs, 'id'>>;
  v2PairDayData?: Resolver<Maybe<ResolversTypes['v2PairDayData']>, ParentType, ContextType, RequireFields<QueryV2PairDayDataArgs, 'id'>>;
  v2PairDayDatas?: Resolver<ResolversTypes['v2PairDayDataPage'], ParentType, ContextType, Partial<QueryV2PairDayDatasArgs>>;
  v2PairHourData?: Resolver<Maybe<ResolversTypes['v2PairHourData']>, ParentType, ContextType, RequireFields<QueryV2PairHourDataArgs, 'id'>>;
  v2PairHourDatas?: Resolver<ResolversTypes['v2PairHourDataPage'], ParentType, ContextType, Partial<QueryV2PairHourDatasArgs>>;
  v2PairPriceHistory?: Resolver<Maybe<ResolversTypes['v2PairPriceHistory']>, ParentType, ContextType, RequireFields<QueryV2PairPriceHistoryArgs, 'id'>>;
  v2PairPriceHistorys?: Resolver<ResolversTypes['v2PairPriceHistoryPage'], ParentType, ContextType, Partial<QueryV2PairPriceHistorysArgs>>;
  v2Pairs?: Resolver<ResolversTypes['v2PairPage'], ParentType, ContextType, Partial<QueryV2PairsArgs>>;
  v3Pool?: Resolver<Maybe<ResolversTypes['v3Pool']>, ParentType, ContextType, RequireFields<QueryV3PoolArgs, 'id'>>;
  v3PoolDayData?: Resolver<Maybe<ResolversTypes['v3PoolDayData']>, ParentType, ContextType, RequireFields<QueryV3PoolDayDataArgs, 'id'>>;
  v3PoolDayDatas?: Resolver<ResolversTypes['v3PoolDayDataPage'], ParentType, ContextType, Partial<QueryV3PoolDayDatasArgs>>;
  v3PoolHourData?: Resolver<Maybe<ResolversTypes['v3PoolHourData']>, ParentType, ContextType, RequireFields<QueryV3PoolHourDataArgs, 'id'>>;
  v3PoolHourDatas?: Resolver<ResolversTypes['v3PoolHourDataPage'], ParentType, ContextType, Partial<QueryV3PoolHourDatasArgs>>;
  v3Pools?: Resolver<ResolversTypes['v3PoolPage'], ParentType, ContextType, Partial<QueryV3PoolsArgs>>;
  v4Pool?: Resolver<Maybe<ResolversTypes['v4Pool']>, ParentType, ContextType, RequireFields<QueryV4PoolArgs, 'id'>>;
  v4PoolDayData?: Resolver<Maybe<ResolversTypes['v4PoolDayData']>, ParentType, ContextType, RequireFields<QueryV4PoolDayDataArgs, 'id'>>;
  v4PoolDayDatas?: Resolver<ResolversTypes['v4PoolDayDataPage'], ParentType, ContextType, Partial<QueryV4PoolDayDatasArgs>>;
  v4PoolHourData?: Resolver<Maybe<ResolversTypes['v4PoolHourData']>, ParentType, ContextType, RequireFields<QueryV4PoolHourDataArgs, 'id'>>;
  v4PoolHourDatas?: Resolver<ResolversTypes['v4PoolHourDataPage'], ParentType, ContextType, Partial<QueryV4PoolHourDatasArgs>>;
  v4Pools?: Resolver<ResolversTypes['v4PoolPage'], ParentType, ContextType, Partial<QueryV4PoolsArgs>>;
};

export type ViewPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewPageInfo'] = ResolversParentTypes['ViewPageInfo']> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DailyProtocolTvlResolvers<ContextType = any, ParentType extends ResolversParentTypes['dailyProtocolTvl'] = ResolversParentTypes['dailyProtocolTvl']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DailyProtocolTvlPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['dailyProtocolTvlPage'] = ResolversParentTypes['dailyProtocolTvlPage']> = {
  items?: Resolver<Array<ResolversTypes['dailyProtocolTvl']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FactoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['factory'] = ResolversParentTypes['factory']> = {
  dayData?: Resolver<Maybe<ResolversTypes['factoryDayDataPage']>, ParentType, ContextType, Partial<FactoryDayDataArgs>>;
  ethPrice?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hourData?: Resolver<Maybe<ResolversTypes['factoryHourDataPage']>, ParentType, ContextType, Partial<FactoryHourDataArgs>>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pairCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  poolCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tokenListUpdatedAt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalFeesETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalFeesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalLiquidityETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalLiquidityUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedETHUntracked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSDUntracked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalVolumeETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FactoryDayDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['factoryDayData'] = ResolversParentTypes['factoryDayData']> = {
  date?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dayId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  factory?: Resolver<Maybe<ResolversTypes['factory']>, ParentType, ContextType>;
  factoryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  tvlUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  volumeETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSDUntracked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FactoryDayDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['factoryDayDataPage'] = ResolversParentTypes['factoryDayDataPage']> = {
  items?: Resolver<Array<ResolversTypes['factoryDayData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FactoryHourDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['factoryHourData'] = ResolversParentTypes['factoryHourData']> = {
  date?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  factory?: Resolver<Maybe<ResolversTypes['factory']>, ParentType, ContextType>;
  factoryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hourId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  tvlUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  volumeETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSDUntracked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FactoryHourDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['factoryHourDataPage'] = ResolversParentTypes['factoryHourDataPage']> = {
  items?: Resolver<Array<ResolversTypes['factoryHourData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FactoryPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['factoryPage'] = ResolversParentTypes['factoryPage']> = {
  items?: Resolver<Array<ResolversTypes['factory']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['feeData'] = ResolversParentTypes['feeData']> = {
  buyFeeBps?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalTransferFailed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  feeTakenOnTransfer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sellFeeBps?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellReverted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  tokenId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['feeDataPage'] = ResolversParentTypes['feeDataPage']> = {
  items?: Resolver<Array<ResolversTypes['feeData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HistoricalProtocolVolumeResolvers<ContextType = any, ParentType extends ResolversParentTypes['historicalProtocolVolume'] = ResolversParentTypes['historicalProtocolVolume']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HistoricalProtocolVolumePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['historicalProtocolVolumePage'] = ResolversParentTypes['historicalProtocolVolumePage']> = {
  items?: Resolver<Array<ResolversTypes['historicalProtocolVolume']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HistoricalTvlResolvers<ContextType = any, ParentType extends ResolversParentTypes['historicalTvl'] = ResolversParentTypes['historicalTvl']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  tokenId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenMarket?: Resolver<Maybe<ResolversTypes['tokenMarket']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HistoricalTvlPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['historicalTvlPage'] = ResolversParentTypes['historicalTvlPage']> = {
  items?: Resolver<Array<ResolversTypes['historicalTvl']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HistoricalVolumeResolvers<ContextType = any, ParentType extends ResolversParentTypes['historicalVolume'] = ResolversParentTypes['historicalVolume']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  tokenId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenMarket?: Resolver<Maybe<ResolversTypes['tokenMarket']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HistoricalVolumePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['historicalVolumePage'] = ResolversParentTypes['historicalVolumePage']> = {
  items?: Resolver<Array<ResolversTypes['historicalVolume']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OriginTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['originToken'] = ResolversParentTypes['originToken']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['chain'], ParentType, ContextType>;
  decimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  indexText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  standard?: Resolver<ResolversTypes['standard'], ParentType, ContextType>;
  symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  tokenId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OriginTokenPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['originTokenPage'] = ResolversParentTypes['originTokenPage']> = {
  items?: Resolver<Array<ResolversTypes['originToken']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PairHistoricalVolumeResolvers<ContextType = any, ParentType extends ResolversParentTypes['pairHistoricalVolume'] = ResolversParentTypes['pairHistoricalVolume']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pair?: Resolver<Maybe<ResolversTypes['v2Pair']>, ParentType, ContextType>;
  pairId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PairHistoricalVolumePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['pairHistoricalVolumePage'] = ResolversParentTypes['pairHistoricalVolumePage']> = {
  items?: Resolver<Array<ResolversTypes['pairHistoricalVolume']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PoolTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['poolTransaction'] = ResolversParentTypes['poolTransaction']> = {
  account?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['chain'], ParentType, ContextType>;
  hash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  poolId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  token0?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  token0Id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token0Quantity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  token1Id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token1Quantity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['poolTransactionType'], ParentType, ContextType>;
  usdValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PoolTransactionPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['poolTransactionPage'] = ResolversParentTypes['poolTransactionPage']> = {
  items?: Resolver<Array<ResolversTypes['poolTransaction']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PositionResolvers<ContextType = any, ParentType extends ResolversParentTypes['position'] = ResolversParentTypes['position']> = {
  chain?: Resolver<ResolversTypes['chain'], ParentType, ContextType>;
  feeTier?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  token0?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  token0Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  token1Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  v2Pair?: Resolver<Maybe<ResolversTypes['v2Pair']>, ParentType, ContextType>;
  v2PairId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  v3Pool?: Resolver<Maybe<ResolversTypes['v3Pool']>, ParentType, ContextType>;
  v3PoolId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  v4Pool?: Resolver<Maybe<ResolversTypes['v4Pool']>, ParentType, ContextType>;
  v4PoolId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PositionPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['positionPage'] = ResolversParentTypes['positionPage']> = {
  items?: Resolver<Array<ResolversTypes['position']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['priceHistory'] = ResolversParentTypes['priceHistory']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  tokenId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenMarket?: Resolver<Maybe<ResolversTypes['tokenMarket']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceHistoryPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['priceHistoryPage'] = ResolversParentTypes['priceHistoryPage']> = {
  items?: Resolver<Array<ResolversTypes['priceHistory']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimestampedOhlcResolvers<ContextType = any, ParentType extends ResolversParentTypes['timestampedOhlc'] = ResolversParentTypes['timestampedOhlc']> = {
  close?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  high?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  low?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  open?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tokenId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenMarket?: Resolver<Maybe<ResolversTypes['tokenMarket']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimestampedOhlcPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['timestampedOhlcPage'] = ResolversParentTypes['timestampedOhlcPage']> = {
  items?: Resolver<Array<ResolversTypes['timestampedOhlc']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['token'] = ResolversParentTypes['token']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['chain'], ParentType, ContextType>;
  dayData?: Resolver<Maybe<ResolversTypes['tokenDayDataPage']>, ParentType, ContextType, Partial<TokenDayDataArgs>>;
  decimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  derivedETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feeData?: Resolver<Maybe<ResolversTypes['feeData']>, ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hourData?: Resolver<Maybe<ResolversTypes['tokenHourDataPage']>, ParentType, ContextType, Partial<TokenHourDataArgs>>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  indexText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  market?: Resolver<Maybe<ResolversTypes['tokenMarket']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originToken?: Resolver<Maybe<ResolversTypes['originToken']>, ParentType, ContextType>;
  originTokenId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  standard?: Resolver<ResolversTypes['standard'], ParentType, ContextType>;
  symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalValueLocked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeVolume?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactions?: Resolver<Maybe<ResolversTypes['poolTransactionPage']>, ParentType, ContextType, Partial<TokenTransactionsArgs>>;
  txCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  v3WhitelistPools?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  v4WhitelistPools?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenDayDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['tokenDayData'] = ResolversParentTypes['tokenDayData']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  close?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dayId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  high?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  low?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  tokenId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLocked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volume?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenDayDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['tokenDayDataPage'] = ResolversParentTypes['tokenDayDataPage']> = {
  items?: Resolver<Array<ResolversTypes['tokenDayData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenHourDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['tokenHourData'] = ResolversParentTypes['tokenHourData']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  close?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dayId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  high?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  low?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  tokenId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLocked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volume?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenHourDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['tokenHourDataPage'] = ResolversParentTypes['tokenHourDataPage']> = {
  items?: Resolver<Array<ResolversTypes['tokenHourData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenMarketResolvers<ContextType = any, ParentType extends ResolversParentTypes['tokenMarket'] = ResolversParentTypes['tokenMarket']> = {
  historicalTvl?: Resolver<Maybe<ResolversTypes['historicalTvlPage']>, ParentType, ContextType, Partial<TokenMarketHistoricalTvlArgs>>;
  historicalVolume?: Resolver<Maybe<ResolversTypes['historicalVolumePage']>, ParentType, ContextType, Partial<TokenMarketHistoricalVolumeArgs>>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ohlc?: Resolver<Maybe<ResolversTypes['timestampedOhlcPage']>, ParentType, ContextType, Partial<TokenMarketOhlcArgs>>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  priceHighLow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  priceHistory?: Resolver<Maybe<ResolversTypes['priceHistoryPage']>, ParentType, ContextType, Partial<TokenMarketPriceHistoryArgs>>;
  pricePercentChange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  priceSource?: Resolver<ResolversTypes['priceSource'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  tokenId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalValueLocked?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  volume?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenMarketPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['tokenMarketPage'] = ResolversParentTypes['tokenMarketPage']> = {
  items?: Resolver<Array<ResolversTypes['tokenMarket']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['tokenPage'] = ResolversParentTypes['tokenPage']> = {
  items?: Resolver<Array<ResolversTypes['token']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['user'] = ResolversParentTypes['user']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdSwapped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['userPage'] = ResolversParentTypes['userPage']> = {
  items?: Resolver<Array<ResolversTypes['user']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V2PairResolvers<ContextType = any, ParentType extends ResolversParentTypes['v2Pair'] = ResolversParentTypes['v2Pair']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['chain'], ParentType, ContextType>;
  createdAtBlockNumber?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAtTimestamp?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  cumulativeVolume?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dayData?: Resolver<Maybe<ResolversTypes['v2PairDayDataPage']>, ParentType, ContextType, Partial<V2PairDayDataArgs>>;
  hourData?: Resolver<Maybe<ResolversTypes['v2PairHourDataPage']>, ParentType, ContextType, Partial<V2PairHourDataArgs>>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  indexText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  liquidity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  reserve0?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  reserve1?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  token0?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  token0Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Supply?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  token1Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Supply?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalLiquidity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalLiquidityPercentChange24h?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalSupply?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trackedReserveETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V2PairDayDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['v2PairDayData'] = ResolversParentTypes['v2PairDayData']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dayId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pair?: Resolver<Maybe<ResolversTypes['v2Pair']>, ParentType, ContextType>;
  pairId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  token0Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Supply?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Supply?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V2PairDayDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['v2PairDayDataPage'] = ResolversParentTypes['v2PairDayDataPage']> = {
  items?: Resolver<Array<ResolversTypes['v2PairDayData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V2PairHourDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['v2PairHourData'] = ResolversParentTypes['v2PairHourData']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dayId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pair?: Resolver<Maybe<ResolversTypes['v2Pair']>, ParentType, ContextType>;
  pairId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  token0Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Supply?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Supply?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V2PairHourDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['v2PairHourDataPage'] = ResolversParentTypes['v2PairHourDataPage']> = {
  items?: Resolver<Array<ResolversTypes['v2PairHourData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V2PairPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['v2PairPage'] = ResolversParentTypes['v2PairPage']> = {
  items?: Resolver<Array<ResolversTypes['v2Pair']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V2PairPriceHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['v2PairPriceHistory'] = ResolversParentTypes['v2PairPriceHistory']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pair?: Resolver<Maybe<ResolversTypes['v2Pair']>, ParentType, ContextType>;
  pairId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  token0Price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  token1Price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V2PairPriceHistoryPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['v2PairPriceHistoryPage'] = ResolversParentTypes['v2PairPriceHistoryPage']> = {
  items?: Resolver<Array<ResolversTypes['v2PairPriceHistory']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V3PoolResolvers<ContextType = any, ParentType extends ResolversParentTypes['v3Pool'] = ResolversParentTypes['v3Pool']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['chain'], ParentType, ContextType>;
  collectedFeesToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  collectedFeesToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  collectedFeesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAtBlockNumber?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAtTimestamp?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dayData?: Resolver<Maybe<ResolversTypes['v3PoolDayDataPage']>, ParentType, ContextType, Partial<V3PoolDayDataArgs>>;
  feeTier?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hourData?: Resolver<Maybe<ResolversTypes['v3PoolHourDataPage']>, ParentType, ContextType, Partial<V3PoolHourDataArgs>>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  indexText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  liquidity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  liquidityProviderCount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  observationIndex?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  sqrtPrice?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tick?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  token0?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  token0Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  token1Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSDUntracked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V3PoolDayDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['v3PoolDayData'] = ResolversParentTypes['v3PoolDayData']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  close?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dayId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  high?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  low?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pool?: Resolver<Maybe<ResolversTypes['v3Pool']>, ParentType, ContextType>;
  poolId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  token0Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V3PoolDayDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['v3PoolDayDataPage'] = ResolversParentTypes['v3PoolDayDataPage']> = {
  items?: Resolver<Array<ResolversTypes['v3PoolDayData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V3PoolHourDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['v3PoolHourData'] = ResolversParentTypes['v3PoolHourData']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  close?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dayId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  high?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  low?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pool?: Resolver<Maybe<ResolversTypes['v3Pool']>, ParentType, ContextType>;
  poolId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  token0Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V3PoolHourDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['v3PoolHourDataPage'] = ResolversParentTypes['v3PoolHourDataPage']> = {
  items?: Resolver<Array<ResolversTypes['v3PoolHourData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V3PoolPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['v3PoolPage'] = ResolversParentTypes['v3PoolPage']> = {
  items?: Resolver<Array<ResolversTypes['v3Pool']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V4PoolResolvers<ContextType = any, ParentType extends ResolversParentTypes['v4Pool'] = ResolversParentTypes['v4Pool']> = {
  chain?: Resolver<ResolversTypes['chain'], ParentType, ContextType>;
  collectedFeesToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  collectedFeesToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  collectedFeesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAtBlockNumber?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  createdAtTimestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dayData?: Resolver<Maybe<ResolversTypes['v4PoolDayDataPage']>, ParentType, ContextType, Partial<V4PoolDayDataArgs>>;
  feeTier?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hooks?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hourData?: Resolver<Maybe<ResolversTypes['v4PoolHourDataPage']>, ParentType, ContextType, Partial<V4PoolHourDataArgs>>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  indexText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  liquidity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  liquidityProviderCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  observationIndex?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  poolId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  sqrtPrice?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tick?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tickSpacing?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  token0?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  token0Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1?: Resolver<Maybe<ResolversTypes['token']>, ParentType, ContextType>;
  token1Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedETH?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalValueLockedUSDUntracked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V4PoolDayDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['v4PoolDayData'] = ResolversParentTypes['v4PoolDayData']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  close?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dayId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  high?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  low?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pool?: Resolver<Maybe<ResolversTypes['v4Pool']>, ParentType, ContextType>;
  poolId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  token0Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V4PoolDayDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['v4PoolDayDataPage'] = ResolversParentTypes['v4PoolDayDataPage']> = {
  items?: Resolver<Array<ResolversTypes['v4PoolDayData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V4PoolHourDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['v4PoolHourData'] = ResolversParentTypes['v4PoolHourData']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  close?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dayId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  feesUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  high?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  low?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pool?: Resolver<Maybe<ResolversTypes['v4Pool']>, ParentType, ContextType>;
  poolId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolVersion?: Resolver<ResolversTypes['protocolVersion'], ParentType, ContextType>;
  token0Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token0Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token1Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  untrackedVolumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken0?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeToken1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volumeUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V4PoolHourDataPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['v4PoolHourDataPage'] = ResolversParentTypes['v4PoolHourDataPage']> = {
  items?: Resolver<Array<ResolversTypes['v4PoolHourData']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type V4PoolPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['v4PoolPage'] = ResolversParentTypes['v4PoolPage']> = {
  items?: Resolver<Array<ResolversTypes['v4Pool']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  BigInt?: GraphQLScalarType;
  JSON?: GraphQLScalarType;
  Meta?: MetaResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ViewPageInfo?: ViewPageInfoResolvers<ContextType>;
  dailyProtocolTvl?: DailyProtocolTvlResolvers<ContextType>;
  dailyProtocolTvlPage?: DailyProtocolTvlPageResolvers<ContextType>;
  factory?: FactoryResolvers<ContextType>;
  factoryDayData?: FactoryDayDataResolvers<ContextType>;
  factoryDayDataPage?: FactoryDayDataPageResolvers<ContextType>;
  factoryHourData?: FactoryHourDataResolvers<ContextType>;
  factoryHourDataPage?: FactoryHourDataPageResolvers<ContextType>;
  factoryPage?: FactoryPageResolvers<ContextType>;
  feeData?: FeeDataResolvers<ContextType>;
  feeDataPage?: FeeDataPageResolvers<ContextType>;
  historicalProtocolVolume?: HistoricalProtocolVolumeResolvers<ContextType>;
  historicalProtocolVolumePage?: HistoricalProtocolVolumePageResolvers<ContextType>;
  historicalTvl?: HistoricalTvlResolvers<ContextType>;
  historicalTvlPage?: HistoricalTvlPageResolvers<ContextType>;
  historicalVolume?: HistoricalVolumeResolvers<ContextType>;
  historicalVolumePage?: HistoricalVolumePageResolvers<ContextType>;
  originToken?: OriginTokenResolvers<ContextType>;
  originTokenPage?: OriginTokenPageResolvers<ContextType>;
  pairHistoricalVolume?: PairHistoricalVolumeResolvers<ContextType>;
  pairHistoricalVolumePage?: PairHistoricalVolumePageResolvers<ContextType>;
  poolTransaction?: PoolTransactionResolvers<ContextType>;
  poolTransactionPage?: PoolTransactionPageResolvers<ContextType>;
  position?: PositionResolvers<ContextType>;
  positionPage?: PositionPageResolvers<ContextType>;
  priceHistory?: PriceHistoryResolvers<ContextType>;
  priceHistoryPage?: PriceHistoryPageResolvers<ContextType>;
  timestampedOhlc?: TimestampedOhlcResolvers<ContextType>;
  timestampedOhlcPage?: TimestampedOhlcPageResolvers<ContextType>;
  token?: TokenResolvers<ContextType>;
  tokenDayData?: TokenDayDataResolvers<ContextType>;
  tokenDayDataPage?: TokenDayDataPageResolvers<ContextType>;
  tokenHourData?: TokenHourDataResolvers<ContextType>;
  tokenHourDataPage?: TokenHourDataPageResolvers<ContextType>;
  tokenMarket?: TokenMarketResolvers<ContextType>;
  tokenMarketPage?: TokenMarketPageResolvers<ContextType>;
  tokenPage?: TokenPageResolvers<ContextType>;
  user?: UserResolvers<ContextType>;
  userPage?: UserPageResolvers<ContextType>;
  v2Pair?: V2PairResolvers<ContextType>;
  v2PairDayData?: V2PairDayDataResolvers<ContextType>;
  v2PairDayDataPage?: V2PairDayDataPageResolvers<ContextType>;
  v2PairHourData?: V2PairHourDataResolvers<ContextType>;
  v2PairHourDataPage?: V2PairHourDataPageResolvers<ContextType>;
  v2PairPage?: V2PairPageResolvers<ContextType>;
  v2PairPriceHistory?: V2PairPriceHistoryResolvers<ContextType>;
  v2PairPriceHistoryPage?: V2PairPriceHistoryPageResolvers<ContextType>;
  v3Pool?: V3PoolResolvers<ContextType>;
  v3PoolDayData?: V3PoolDayDataResolvers<ContextType>;
  v3PoolDayDataPage?: V3PoolDayDataPageResolvers<ContextType>;
  v3PoolHourData?: V3PoolHourDataResolvers<ContextType>;
  v3PoolHourDataPage?: V3PoolHourDataPageResolvers<ContextType>;
  v3PoolPage?: V3PoolPageResolvers<ContextType>;
  v4Pool?: V4PoolResolvers<ContextType>;
  v4PoolDayData?: V4PoolDayDataResolvers<ContextType>;
  v4PoolDayDataPage?: V4PoolDayDataPageResolvers<ContextType>;
  v4PoolHourData?: V4PoolHourDataResolvers<ContextType>;
  v4PoolHourDataPage?: V4PoolHourDataPageResolvers<ContextType>;
  v4PoolPage?: V4PoolPageResolvers<ContextType>;
};

